unit dashboard.maintenance;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCGridCell,
  VCL.TMSFNCGridOptions, XData.Web.Client, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCCustomGrid, VCL.TMSFNCGridDatabaseAdapter, VCL.TMSFNCCustomControl,
  VCL.TMSFNCCustomScrollControl, VCL.TMSFNCGridData, VCL.TMSFNCGrid,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls, Data.DB,
  WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.Buttons,
  System.Variants, WEBLib.DBCtrls, Vcl.Imaging.GIFImg, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer,
  VCL.TMSFNCDataGridDatabaseAdapter, VCL.TMSFNCDataGrid,
  VCL.TMSFNCBitmapContainer;

type
  TfrmDashBoardMaintenance = class(TForm)
    pTop: TPanel;
    pBottom: TPanel;
    pMain: TPanel;
    wcYears: TXDataWebClient;
    wdsYears: TXDataWebDataSet;
    dsYears: TDataSource;
    wcMonths: TXDataWebClient;
    wdsMonths: TXDataWebDataSet;
    dsMonths: TDataSource;
    wdsMonthsMonth: TIntegerField;
    wdsMonthsMonthName: TStringField;
    wdsYearsSelected: TBooleanField;
    wdsMonthsSelected: TBooleanField;
    wdsYearsYear: TIntegerField;
    pMainTop: TPanel;
    pMainMonths: TPanel;
    WebLabel2: TLabel;
    pMainYears: TPanel;
    WebLabel1: TLabel;
    pRegNo: TPanel;
    WebLabel3: TLabel;
    WebButton1: TButton;
    btnRegClear: TSpeedButton;
    wcReg: TXDataWebClient;
    wdsReg: TXDataWebDataSet;
    dsReg: TDataSource;
    wdsRegReg: TStringField;
    wdsRegFleetNo: TStringField;
    wdsRegFleetType: TStringField;
    wdsRegSelected: TBooleanField;
    WebTimer1: TTimer;
    wdsRegPriKey: TIntegerField;
    wdsTempReg: TXDataWebDataSet;
    StringField1: TStringField;
    StringField2: TStringField;
    StringField3: TStringField;
    BooleanField1: TBooleanField;
    IntegerField1: TIntegerField;
    pMaintTypes: TPanel;
    dsSysTypes: TDataSource;
    wcSysTypes: TXDataWebClient;
    wdsSysTypes: TXDataWebDataSet;
    wdsSysTypesSelected: TBooleanField;
    WebLabel4: TLabel;
    pCostGroups: TPanel;
    WebLabel5: TLabel;
    wdsCostGroups: TXDataWebDataSet;
    dsCostGroups: TDataSource;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    wcCostGroups: TXDataWebClient;
    wdsSysTypesSysType: TIntegerField;
    wdsSysTypesDescription: TStringField;
    wdsCostGroupsDescription: TStringField;
    wdsCostGroupsselected: TBooleanField;
    wdsDashboardSums: TXDataWebDataSet;
    wdsDashData: TXDataWebDataSet;
    wcDashboardSums: TXDataWebClient;
    dsDashBoardSums: TDataSource;
    wcDashData: TXDataWebClient;
    dsDashData: TDataSource;
    wpDashSums: TPanel;
    pDashData: TPanel;
    wpTotalCost: TPanel;
    WebDBLabel1: TDBLabel;
    WebLabel6: TLabel;
    wpMaintenance: TPanel;
    WebLabel7: TLabel;
    WebDBLabel2: TDBLabel;
    wpTyres: TPanel;
    wpCost: TPanel;
    wpInsurance: TPanel;
    wpOperational: TPanel;
    WebDBLabel5: TDBLabel;
    WebDBLabel3: TDBLabel;
    WebDBLabel4: TDBLabel;
    WebDBLabel6: TDBLabel;
    WebLabel8: TLabel;
    WebLabel9: TLabel;
    WebLabel10: TLabel;
    WebLabel11: TLabel;
    wdsDashboardSumsMaintenanceCost: TStringField;
    wdsDashboardSumsTyreCost: TStringField;
    wdsDashboardSumsWashCost: TStringField;
    wdsDashboardSumsInsuranceCost: TStringField;
    wdsDashboardSumsOtherCost: TStringField;
    wdsDashboardSumsTotalCost: TStringField;
    wdsDashDataJobcardNo: TIntegerField;
    wdsDashDataStockDescription: TStringField;
    wdsDashDataTotalExcl: TStringField;
    wdsDashDataGlCode: TStringField;
    wdsDashDataReason: TStringField;
    wdsDashDataCategory: TStringField;
    wdsDashDataRepMain: TStringField;
    wdsDashDataCostDescription: TStringField;
    wdsDashDataTRegNo: TStringField;
    wdsDashDataTFleetNo: TStringField;
    wdsDashDataOrderNo: TStringField;
    wdsDashDataJobDate: TStringField;
    wdsDashDataReferenceNo: TStringField;
    wdsDashDataVehType: TStringField;
    wdsDashDataJobType: TStringField;
    wbSearch: TButton;
    wpCapex: TPanel;
    wpUnAll: TPanel;
    WebLabel13: TLabel;
    WebLabel14: TLabel;
    WebDBLabel7: TDBLabel;
    WebDBLabel8: TDBLabel;
    wdsDashboardSumsCapexCost: TStringField;
    wdsDashboardSumsUnallCost: TStringField;
    WebDBLabel9: TDBLabel;
    WebDBLabel10: TDBLabel;
    WebDBLabel11: TDBLabel;
    WebDBLabel12: TDBLabel;
    WebDBLabel13: TDBLabel;
    WebDBLabel14: TDBLabel;
    WebDBLabel15: TDBLabel;
    WebDBLabel16: TDBLabel;
    WebPanel1: TPanel;
    WebLabel12: TLabel;
    WebLabel15: TLabel;
    WebLabel16: TLabel;
    wdsCostGroupsCost: TIntegerField;
    wdsDashDataSupplier: TStringField;
    btnMonthsClear: TSpeedButton;
    btnYearsClear: TSpeedButton;
    wbExcel: TButton;
    wdsDashboardSumsTotalCPK: TStringField;
    wdsDashboardSumsMaintenanceCPK: TStringField;
    wdsDashboardSumsTyreCPK: TStringField;
    wdsDashboardSumsWashCPK: TStringField;
    wdsDashboardSumsInsuranceCPK: TStringField;
    wdsDashboardSumsOtherCPK: TStringField;
    wdsDashboardSumsCapexCPK: TStringField;
    wdsDashboardSumsUnallCPK: TStringField;
    wpNoLink: TPanel;
    WebLabel17: TLabel;
    WebDBLabel17: TDBLabel;
    wdsDashboardSumsNotLinkedCost: TStringField;
    wdsDashboardSumsNotLinkedCPK: TStringField;
    WebDBLabel18: TDBLabel;
    dgDashData: TTMSFNCDataGrid;
    dgdaDashData: TTMSFNCDataGridDatabaseAdapter;
    WebWaitMessage1: TWaitMessage;
    wpSuppliers: TPanel;
    WebLabel18: TLabel;
    WebSpeedButton3: TSpeedButton;
    BitmapContainer1: TTMSFNCBitmapContainer;
    dgMonths: TTMSFNCDataGrid;
    dgdaMonths: TTMSFNCDataGridDatabaseAdapter;
    dgYears: TTMSFNCDataGrid;
    dgdaYears: TTMSFNCDataGridDatabaseAdapter;
    dgReg: TTMSFNCDataGrid;
    dgdaReg: TTMSFNCDataGridDatabaseAdapter;
    dgSysTypes: TTMSFNCDataGrid;
    dgdaSysTypes: TTMSFNCDataGridDatabaseAdapter;
    dgCostGroups: TTMSFNCDataGrid;
    dgdaCostGroups: TTMSFNCDataGridDatabaseAdapter;
    dgSuppliers: TTMSFNCDataGrid;
    dgdaSuppliers: TTMSFNCDataGridDatabaseAdapter;
    wdsSuppliers: TXDataWebDataSet;
    wcSuppliers: TXDataWebClient;
    dsSuppliers: TDataSource;
    wdsSuppliersCrName: TStringField;
    wdsSuppliersCrNumber: TStringField;
    wdsSuppliersSelected: TBooleanField;
    wpVehGroups: TPanel;
    WebLabel20: TLabel;
    WebSpeedButton5: TSpeedButton;
    dgVehGroup: TTMSFNCDataGrid;
    dgdaVehGroups: TTMSFNCDataGridDatabaseAdapter;
    wdsVehGroups: TXDataWebDataSet;
    wcVehGroups: TXDataWebClient;
    dsVehGroups: TDataSource;
    wdsVehGroupsSysType: TStringField;
    wdsVehGroupsDescription: TStringField;
    wdsVehGroupsSelected: TBooleanField;
    procedure WebFormShow(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
    procedure btnRegClearClick(Sender: TObject);
    procedure wdsYearsAfterPost(DataSet: TDataSet);
    procedure wdsMonthsAfterPost(DataSet: TDataSet);
    procedure WebTimer1Timer(Sender: TObject);
    procedure wdsSysTypesAfterPost(DataSet: TDataSet);
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure WebSpeedButton2Click(Sender: TObject);
    procedure wdsCostGroupsAfterPost(DataSet: TDataSet);
    procedure wbSearchClick(Sender: TObject);
    procedure wdsDashboardSumsAfterOpen(DataSet: TDataSet);
    procedure wdsDashDataAfterOpen(DataSet: TDataSet);
    procedure gDashDataSortFormat(Sender: TObject; Col: Integer;
      var SortFormat: TTMSFNCGridSortFormat; var APrefix, ASuffix: string);
    procedure btnMonthsClearClick(Sender: TObject);
    procedure btnYearsClearClick(Sender: TObject);
    procedure wbExcelClick(Sender: TObject);
    procedure CallMaintReport(sFilename, sReport : String);
    procedure WebButton2Click(Sender: TObject);
    procedure dgYearsCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure dgMonthsCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure dgMonthsGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgYearsGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgRegCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure dgRegGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgSysTypesGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgCostGroupsCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure dgSysTypesCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure dgCostGroupsGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure wdsSuppliersAfterPost(DataSet: TDataSet);
    procedure WebSpeedButton5Click(Sender: TObject);
    procedure WebSpeedButton3Click(Sender: TObject);
    procedure dgSuppliersCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure dgSuppliersGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgVehGroupGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgVehGroupCellClick(Sender: TObject; AColumn, ARow: Integer);
  private
    { Private declarations }
    procedure DoRegInfo;
    procedure TriggerTimer;


  public
    { Public declarations }
    procedure DoLoadYears;
    procedure DoLoadMonths;
    procedure DoLoadSystemTypes;
    procedure DoLoadCostGroups;
    Procedure DoLoadSuppliers;
    Procedure DoLoadVehGroups;
    //Procedure DoLoadVehTypes;
    procedure DoLoadMainData;
    Procedure DoLoadMainDataDetails;

    //procedure downloadxlsx(Report : String; iParam : Integer; Param1, Param2, Param3, Param4, Param5, Param6, Param7, Param8, Param9, Param10 : JSValue);
    [Async]
    procedure downloadfile(Report, sFileName : String; Param : Array of JSValue); async;
  protected procedure LoadDFMValues; override; end;

  TTMSFNCGridDataBaseAdapterOpen = class(TTMSFNCGridDataBaseAdapter);

var
  frmDashBoardMaintenance: TfrmDashBoardMaintenance;

implementation

{$R *.dfm}

uses
  stfmssystem.connection,
  share.common,
  share.classes;

{ TfrmDashBoardMaintenance }

procedure TfrmDashBoardMaintenance.downloadfile(Report, sFileName : String; Param : Array of JSValue);
  var
    filesize,
    I, ArrayCount : Integer;
    AB : TJSArrayBuffer;
    AV : TJSUInt8Array;

    Client : TXDataWebClient;
    Response : TXDataClientResponse;
    FileData : WideString;

    DirectDownload : TDirectDownload;


    FileName : string;
begin
  filesize := -1;
  Client            := TXDataWebClient.Create(nil);
  Client.Connection := dmdata.dbConnect;

  // Get File
  try
    Response := await(Client.RawInvokeAsync(Report, Param));
  except
    on Error: Exception do
    begin
      Client.Free;
      console.log('ERROR: '+Error.Classname+' ('+Error.Message+')+ ');
      exit;
    end;
  end;

  DirectDownload := TDirectDownload.Create;
  DirectDownload := TDirectDownload(Response.Result);

  // Convert file
  try
    FileName := string(DirectDownload.Filename);
    asm FileData = window.atob(DirectDownload.Data); end;

    filesize := Length(FileData);
  except on E: Exception do
    begin
      console.log('ERROR: (Base64) File could not be decoded');
      raise Exception.Create('ERROR: (Base64) File could not be decoded');
    end;
  end;

  if (filesize <> -1) then
  begin
    console.log('Retrieved (Base64) File: '+IntToStr(length(FileData))+' bytes');
    console.log('Decoded (Base64) File: '+IntToStr(filesize)+' bytes');
  end;

  Client.Free;

  if (filesize <> -1) then
    begin
      AB := TJSArrayBuffer.new(filesize);
      AV := TJSUInt8Array.new(AB);
      for i := 0 to filesize - 1 do
        AV[i] := TJSString(FileData).charCodeAt(i);
      Application.DownloadBinaryFile(AV, sFilename);
    end
  else
    begin
      // what/how do you want to tell the user about a failure here
    end;
  DirectDownload.Free;
end;

procedure TfrmDashBoardMaintenance.btnRegClearClick(Sender: TObject);
begin
  wdsReg.DisableControls;
  wdsReg.First;
  Repeat
    If wdsReg.FieldByName('Selected').asBoolean then
      begin
        wdsReg.Edit;
        wdsReg.FieldByName('Selected').asBoolean := False;
        wdsReg.Post;
      end;
    wdsReg.Next;
  Until wdsReg.Eof;
  wdsReg.First;
  wdsReg.EnableControls;
end;

procedure TfrmDashBoardMaintenance.btnYearsClearClick(Sender: TObject);
begin
  wdsYears.DisableControls;
  wdsYears.First;
  Repeat
    If wdsYears.FieldByName('Selected').asBoolean then
      begin
        wdsYears.Edit;
        wdsYears.FieldByName('Selected').asBoolean := False;
        wdsYears.Post;
      end;
    wdsYears.Next;
  Until wdsYears.Eof;
  wdsYears.First;
  wdsYears.EnableControls;
end;

procedure TfrmDashBoardMaintenance.DoLoadMainData;
  procedure OnResult(Response : TXDataClientResponse);
  begin
    wdsDashboardSums.Close;
    wdsDashboardSums.SetJsonData(Response.Result);
    wdsDashboardSums.Open;

  end;

begin
  wcDashboardSums.RawInvoke('IdashboardService.GetJobcardTypeTotals', [GetJsonArrayFromDataSet(wdsYears,true,'Selected'),
                                                                       GetJsonArrayFromDataSet(wdsMonths,true,'Selected'),
                                                                       GetJsonArrayFromDataSet(wdsReg,true,'Selected'),
                                                                       GetJsonArrayFromDataSet(wdsSysTypes,true,'Selected'),
                                                                       GetJsonArrayFromDataSet(wdsCostGroups,true,'Selected'),
                                                                       GetJsonArrayFromDataSet(wdsSuppliers,true,'Selected'),
                                                                       GetJsonArrayFromDataSet(wdsVehGroups,true,'Selected')], @OnResult);
end;

procedure TfrmDashBoardMaintenance.DoLoadMainDataDetails;
  procedure OnResult(Response : TXDataClientResponse);
  begin
    wdsDashData.Close;
    wdsDashData.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
    wdsDashData.Open;
  end;

begin
  wcDashData.RawInvoke('IdashboardService.GetJobcardDetails', [GetJsonArrayFromDataSet(wdsYears,true,'Selected'),
                                                               GetJsonArrayFromDataSet(wdsMonths,true,'Selected'),
                                                               GetJsonArrayFromDataSet(wdsReg,true,'Selected'),
                                                               GetJsonArrayFromDataSet(wdsSysTypes,true,'Selected'),
                                                               GetJsonArrayFromDataSet(wdsCostGroups,true,'Selected'),
                                                               GetJsonArrayFromDataSet(wdsSuppliers,true,'Selected'),
                                                               GetJsonArrayFromDataSet(wdsVehGroups,true,'Selected')], @OnResult);
end;

procedure TfrmDashBoardMaintenance.DoLoadMonths;
  procedure OnError(Error: TXDataClientError);
    begin
      DoLoadMonths;
    end;
  procedure OnResultMonths(Response : TXDataClientResponse);
   begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        DoLoadMonths;
      end
    else
      begin
        wdsMonths.Close;
        wdsMonths.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsMonths.Open;
        DoLoadSystemTypes;
      end;
   end;

begin
  wcMonths.RawInvoke('IdashboardService.GetMonths', [4], @OnResultMonths, @OnError);
end;

procedure TfrmDashBoardMaintenance.DoLoadYears;
  procedure OnError(Error: TXDataClientError);
  begin
    DoLoadYears;
  end;

  procedure OnResultYears(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        DoLoadYears;
      end
    else
      begin
        wdsYears.Close;
        wdsYears.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsYears.Open;
        DoLoadMonths;
      end;
  end;
begin
  wcYears.RawInvoke('IdashboardService.GetYears', [4], @OnResultYears, @OnError);

end;

procedure TfrmDashBoardMaintenance.DoLoadSystemTypes;
   procedure OnError(Error: TXDataClientError);
  begin
    DoLoadSystemTypes;
  end;

  procedure OnResultSysTypes(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        DoLoadSystemTypes;
      end
    else
      begin
        wdsSysTypes.Close;
        wdsSysTypes.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsSysTypes.Open;
        DoLoadCostGroups;
      end;
  end;

begin
  wcSysTypes.RawInvoke('IdashboardService.GetSysTypes', [], @OnResultSysTypes, @OnError);
end;

procedure TfrmDashBoardMaintenance.DoLoadCostGroups;
  procedure OnError(Error: TXDataClientError);
  begin
    DoLoadCostGroups;
  end;

  procedure OnResultSysTypes(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        DoLoadCostGroups;
      end
    else
      begin
        wdsCostGroups.Close;
        wdsCostGroups.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsCostGroups.Open;
        DoLoadSuppliers;
      end;

  end;
begin
  wcSysTypes.RawInvoke('IdashboardService.GetJobCostDesc', [], @OnResultSysTypes, @OnError);

end;

procedure TfrmDashBoardMaintenance.DoLoadSuppliers;
 procedure OnError(Error: TXDataClientError);
  begin
    DoLoadSuppliers;
  end;

  procedure OnResultSuppliers(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        DoLoadSuppliers;
      end
    else
      begin
        wdsSuppliers.Close;
        wdsSuppliers.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsSuppliers.Open;
        DoLoadVehGroups;
      end;

  end;
begin
  wcSuppliers.RawInvoke('IdashboardService.GetSuppliers', [], @OnResultSuppliers, @OnError);

end;

procedure TfrmDashBoardMaintenance.DoLoadVehGroups;
 procedure OnError(Error: TXDataClientError);
  begin
    DoLoadVehGroups;
  end;

  procedure OnResultSuppliers(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        DoLoadVehGroups;
      end
    else
      begin
        wdsVehGroups.Close;
        wdsVehGroups.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsVehGroups.Open;
        //DoLoadVehTypes;
      end;

  end;
begin
  wcVehGroups.RawInvoke('IdashboardService.GetVehGroups', [], @OnResultSuppliers, @OnError);

end;



procedure TfrmDashBoardMaintenance.DoRegInfo;
  procedure OnResult(Response : TXDataClientResponse);
    var
      iLastKey : Integer;
      iCurrentKey : Integer;
  begin
    If not wdsReg.Active then
      begin
        wdsReg.Close;
        wdsReg.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsReg.Open;
      end
    else
      begin
        wdsTempReg.Close;
        wdsTempReg.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsTempReg.Open;

        iCurrentKey := wdsReg.FieldByName('PriKey').asInteger;
        wdsReg.DisableControls;
        wdsTempReg.First;
        iLastKey := -1;
        Repeat
          If not wdsReg.Locate('PriKey', wdsTempReg.FieldByName('PriKey').asInteger,[]) then
            begin
              If iLastKey > -1 then
                begin
                  wdsReg.Locate('PriKey', iLastKey, []);
                  wdsReg.Insert;
                  wdsReg.FieldByName('Reg').asString       := wdsTempReg.FieldByName('Reg').asString;
                  wdsReg.FieldByName('FleetNo').asString   := wdsTempReg.FieldByName('FleetNo').asString;
                  wdsReg.FieldByName('FleetType').asString := wdsTempReg.FieldByName('FleetType').asString;
                  wdsReg.FieldByName('Selected').asBoolean := wdsTempReg.FieldByName('Selected').asBoolean;
                  wdsReg.FieldByName('PriKey').asInteger   := wdsTempReg.FieldByName('PriKey').asInteger;
                  wdsReg.Post;
                end
              else
                begin
                  wdsReg.First;
                  wdsReg.Insert;
                  wdsReg.FieldByName('Reg').asString       := wdsTempReg.FieldByName('Reg').asString;
                  wdsReg.FieldByName('FleetNo').asString   := wdsTempReg.FieldByName('FleetNo').asString;
                  wdsReg.FieldByName('FleetType').asString := wdsTempReg.FieldByName('FleetType').asString;
                  wdsReg.FieldByName('Selected').asBoolean := wdsTempReg.FieldByName('Selected').asBoolean;
                  wdsReg.FieldByName('PriKey').asInteger   := wdsTempReg.FieldByName('PriKey').asInteger;
                  wdsReg.Post;
                end;
            end;
          iLastKey := wdsTempReg.FieldByName('PriKey').asInteger;
          wdsTempReg.Next;
        Until wdsTempReg.Eof;
        wdsReg.Locate('PriKey', iCurrentKey, []);
        wdsTempReg.Close;
        wdsReg.EnableControls;
      end;
  end;
begin
  wcReg.RawInvoke('IdashboardService.GetReg', [4,GetJsonArrayFromDataSet(wdsYears,true,'Selected'),GetJsonArrayFromDataSet(wdsMonths,true,'Selected')], @OnResult);
end;

procedure TfrmDashBoardMaintenance.gDashDataSortFormat(Sender: TObject;
  Col: Integer; var SortFormat: TTMSFNCGridSortFormat; var APrefix,
  ASuffix: string);
begin
 case Col of

    3 : SortFormat := ssNumeric;
    4 : SortFormat := ssNumeric;
    10 : SortFormat := ssNumeric;


  end;
end;

procedure TfrmDashBoardMaintenance.TriggerTimer;
begin
  WebTimer1.Enabled := False;
  WebTimer1.Enabled := True;
end;

procedure TfrmDashBoardMaintenance.wdsCostGroupsAfterPost(DataSet: TDataSet);
begin
  TriggerTimer;
end;

procedure TfrmDashBoardMaintenance.wdsDashboardSumsAfterOpen(DataSet: TDataSet);
begin
  DoLoadMainDataDetails;
end;

procedure TfrmDashBoardMaintenance.wdsDashDataAfterOpen(DataSet: TDataSet);
begin
   WebWaitMessage1.Hide;
end;

procedure TfrmDashBoardMaintenance.wdsMonthsAfterPost(DataSet: TDataSet);
begin
  TriggerTimer;
end;

procedure TfrmDashBoardMaintenance.wdsSuppliersAfterPost(DataSet: TDataSet);
begin
  TriggerTimer;
end;

procedure TfrmDashBoardMaintenance.wdsSysTypesAfterPost(DataSet: TDataSet);
begin
  TriggerTimer;
end;

procedure TfrmDashBoardMaintenance.wdsYearsAfterPost(DataSet: TDataSet);
begin
  TriggerTimer;
end;

procedure TfrmDashBoardMaintenance.wbExcelClick(Sender: TObject);
begin

  WebWaitMessage1.Show;
  CallMaintReport('Maintdetail.xlsx', 'XLSX');

end;

procedure TfrmDashBoardMaintenance.wbSearchClick(Sender: TObject);
begin
  WebWaitMessage1.Show;
  //gdaDashData.Active := True;
  DoLoadMainData;
    //DoLoadMainDataDetails;

end;

procedure TfrmDashBoardMaintenance.WebButton2Click(Sender: TObject);
begin

  CallMaintReport('Maintdetail.xlsx', 'XLSX');

end;

procedure TfrmDashBoardMaintenance.WebFormResize(Sender: TObject);
begin
  pMainTop.Height := pMain.Height div 3;
end;

procedure TfrmDashBoardMaintenance.WebFormShow(Sender: TObject);
begin
  DoLoadYears;
end;

procedure TfrmDashBoardMaintenance.WebSpeedButton1Click(Sender: TObject);
begin
  wdssysTypes.DisableControls;
  wdssysTypes.First;
  Repeat
    If wdssysTypes.FieldByName('Selected').asBoolean then
      begin
        wdssysTypes.Edit;
        wdssysTypes.FieldByName('Selected').asBoolean := False;
        wdssysTypes.Post;
      end;
    wdssysTypes.Next;
  Until wdssysTypes.Eof;
  wdssysTypes.First;
  wdssysTypes.EnableControls;
end;

procedure TfrmDashBoardMaintenance.WebSpeedButton2Click(Sender: TObject);
begin
  wdsCostGroups.DisableControls;
  wdsCostGroups.First;
  Repeat
    If wdsCostGroups.FieldByName('Selected').asBoolean then
      begin
        wdsCostGroups.Edit;
        wdsCostGroups.FieldByName('Selected').asBoolean := False;
        wdsCostGroups.Post;
      end;
    wdsCostGroups.Next;
  Until wdsCostGroups.Eof;
  wdsCostGroups.First;
  wdsCostGroups.EnableControls;
end;

procedure TfrmDashBoardMaintenance.WebSpeedButton3Click(Sender: TObject);
begin
  wdsSuppliers.DisableControls;
  wdsSuppliers.First;
  Repeat
    If wdsSuppliers.FieldByName('Selected').asBoolean then
      begin
        wdsSuppliers.Edit;
        wdsSuppliers.FieldByName('Selected').asBoolean := False;
        wdsSuppliers.Post;
      end;
    wdsSuppliers.Next;
  Until wdsSuppliers.Eof;
  wdsSuppliers.First;
  wdsSuppliers.EnableControls;
end;

procedure TfrmDashBoardMaintenance.WebSpeedButton5Click(Sender: TObject);
begin
   wdsVehGroups.DisableControls;
  wdsVehGroups.First;
  Repeat
    If wdsVehGroups.FieldByName('Selected').asBoolean then
      begin
        wdsVehGroups.Edit;
        wdsVehGroups.FieldByName('Selected').asBoolean := False;
        wdsVehGroups.Post;
      end;
    wdsVehGroups.Next;
  Until wdsVehGroups.Eof;
  wdsVehGroups.First;
  wdsVehGroups.EnableControls;
end;

procedure TfrmDashBoardMaintenance.btnMonthsClearClick(Sender: TObject);
begin
  wdsMonths.DisableControls;
  wdsMonths.First;
  Repeat
    If wdsMonths.FieldByName('Selected').asBoolean then
      begin
        wdsMonths.Edit;
        wdsMonths.FieldByName('Selected').asBoolean := False;
        wdsMonths.Post;
      end;
    wdsMonths.Next;
  Until wdsMonths.Eof;
  wdsMonths.First;
  wdsMonths.EnableControls;
end;

procedure TfrmDashBoardMaintenance.WebTimer1Timer(Sender: TObject);
begin
  WebTimer1.Enabled := False;
  DoRegInfo;
end;

procedure TfrmDashBoardMaintenance.CallMaintReport( sFilename, sReport : string);
begin


    downloadfile('IdashboardService.GetRepMainDetails',
                 sFileName,
                 [GetJsonArrayFromDataSet(wdsYears,true,'Selected'),
                  GetJsonArrayFromDataSet(wdsMonths,true,'Selected'),
                  GetJsonArrayFromDataSet(wdsReg,true,'Selected'),
                  GetJsonArrayFromDataSet(wdsSysTypes,true,'Selected'),
                  GetJsonArrayFromDataSet(wdsCostGroups,true,'Selected'),
                  sReport]);

    WebWaitMessage1.Hide;



end;

procedure TfrmDashBoardMaintenance.dgCostGroupsCellClick(Sender: TObject;
  AColumn, ARow: Integer);
var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= dgCostGroups.FixedRowCount - 1 then
    Exit;

  d := TTMSFNCGridDataBaseAdapterOpen(dgdaCostGroups);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[2];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsCostGroups.Edit;
                        d.FieldAtColumn[2].asBoolean := False;
                        wdsCostGroups.Post;
                      end
                    else
                      begin
                        wdsCostGroups.Edit;
                        d.FieldAtColumn[2].asBoolean := True;
                        wdsCostGroups.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.dgCostGroupsGetCellProperties(
  Sender: TObject; ACell: TTMSFNCDataGridCell);
begin
 if ACell.IsBitmapCell and dgdaCostGroups.IsValidDataCell(ACell.Coordinate) then
    begin
      if dgCostGroups.Booleans[ACell.Column, ACell.Row] then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[2]
      else
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[3];
    end;
end;

procedure TfrmDashBoardMaintenance.dgMonthsCellClick(Sender: TObject; AColumn,
  ARow: Integer);
var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= dgMonths.FixedRowcount - 1 then
    Exit;

  d := TTMSFNCGridDataBaseAdapterOpen(dgdaMonths);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[2];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsMonths.Edit;
                        d.FieldAtColumn[2].asBoolean := False;
                        wdsMonths.Post;
                      end
                    else
                      begin
                        wdsMonths.Edit;
                        d.FieldAtColumn[2].asBoolean := True;
                        wdsMonths.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.dgMonthsGetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin

  if ACell.IsBitmapCell and dgdaMonths.IsValidDataCell(ACell.Coordinate) then
    begin
      if dgMonths.Booleans[ACell.Column, ACell.Row] then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[2]
      else
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[3];
    end;

end;

procedure TfrmDashBoardMaintenance.dgRegCellClick(Sender: TObject; AColumn,
  ARow: Integer);
var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= dgReg.FixedRowCount - 1 then
    Exit;

  d := TTMSFNCGridDataBaseAdapterOpen(dgdaReg);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[2];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsReg.Edit;
                        d.FieldAtColumn[2].asBoolean := False;
                        wdsReg.Post;
                      end
                    else
                      begin
                        wdsReg.Edit;
                        d.FieldAtColumn[2].asBoolean := True;
                        wdsReg.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.dgRegGetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin

 if ACell.IsBitmapCell and dgdaReg.IsValidDataCell(ACell.Coordinate) then
  begin
    if dgReg.Booleans[ACell.Column, ACell.Row] then
      ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[2]
    else
      ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[3];
  end;

end;

procedure TfrmDashBoardMaintenance.dgSuppliersCellClick(Sender: TObject;
  AColumn, ARow: Integer);
var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= dgSuppliers.FixedRowCount - 1 then
    Exit;

  d := TTMSFNCGridDataBaseAdapterOpen(dgdaSuppliers);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[2];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsSuppliers.Edit;
                        d.FieldAtColumn[2].asBoolean := False;
                        wdsSuppliers.Post;
                      end
                    else
                      begin
                        wdsSuppliers.Edit;
                        d.FieldAtColumn[2].asBoolean := True;
                        wdsSuppliers.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.dgSuppliersGetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
  if ACell.IsBitmapCell and dgdaSuppliers.IsValidDataCell(ACell.Coordinate) then
    begin
      if dgSuppliers.Booleans[ACell.Column, ACell.Row] then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[2]
      else
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[3];
    end;
end;

procedure TfrmDashBoardMaintenance.dgSysTypesCellClick(Sender: TObject; AColumn,
  ARow: Integer);
var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= dgSysTypes.FixedRowCount - 1 then
    Exit;

  d := TTMSFNCGridDataBaseAdapterOpen(dgdaSysTypes);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[2];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsSysTypes.Edit;
                        d.FieldAtColumn[2].asBoolean := False;
                        wdsSysTypes.Post;
                      end
                    else
                      begin
                        wdsSysTypes.Edit;
                        d.FieldAtColumn[2].asBoolean := True;
                        wdsSysTypes.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.dgSysTypesGetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
 if ACell.IsBitmapCell and dgdaSysTypes.IsValidDataCell(ACell.Coordinate) then
  begin
    if dgSysTypes.Booleans[ACell.Column, ACell.Row] then
      ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[2]
    else
      ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[3];
  end;
end;

procedure TfrmDashBoardMaintenance.dgVehGroupCellClick(Sender: TObject;
  AColumn, ARow: Integer);
var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= dgVehGroup.FixedRowCount - 1 then
    Exit;

  d := TTMSFNCGridDataBaseAdapterOpen(dgdaVehGroups);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[2];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsVehGroups.Edit;
                        d.FieldAtColumn[2].asBoolean := False;
                        wdsVehGroups.Post;
                      end
                    else
                      begin
                        wdsVehGroups.Edit;
                        d.FieldAtColumn[2].asBoolean := True;
                        wdsVehGroups.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;
procedure TfrmDashBoardMaintenance.dgVehGroupGetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
  if ACell.IsBitmapCell and dgdaVehGroups.IsValidDataCell(ACell.Coordinate) then
    begin
      if dgVehGroup.Booleans[ACell.Column, ACell.Row] then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[2]
      else
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[3];
    end;
end;

procedure TfrmDashBoardMaintenance.dgYearsCellClick(Sender: TObject;
  AColumn, ARow: Integer);
var
    d: TTMSFNCGridDatabaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= dgYears.FixedRowcount - 1 then
    Exit;

  d := TTMSFNCGridDatabaseAdapterOpen(dgdayears);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[1];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsYears.Edit;
                        d.FieldAtColumn[1].asBoolean := False;
                        wdsYears.Post;
                      end
                    else
                      begin
                        wdsYears.Edit;
                        d.FieldAtColumn[1].asBoolean := True;
                        wdsYears.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.dgYearsGetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
    if ACell.IsBitmapCell and dgdaYears.IsValidDataCell(ACell.Coordinate) then
  begin
    if dgYears.Booleans[ACell.Column, ACell.Row] then
      ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[2]
    else
      ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[3];
  end;
end;

procedure TfrmDashBoardMaintenance.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pTop := TPanel.Create(Self);
  pBottom := TPanel.Create(Self);
  pMain := TPanel.Create(Self);
  pMainTop := TPanel.Create(Self);
  pMainMonths := TPanel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  btnMonthsClear := TSpeedButton.Create(Self);
  dgMonths := TTMSFNCDataGrid.Create(Self);
  dgdaMonths := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  pMainYears := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  btnYearsClear := TSpeedButton.Create(Self);
  dgYears := TTMSFNCDataGrid.Create(Self);
  dgdaYears := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  pRegNo := TPanel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  btnRegClear := TSpeedButton.Create(Self);
  dgReg := TTMSFNCDataGrid.Create(Self);
  dgdaReg := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  pMaintTypes := TPanel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  dgSysTypes := TTMSFNCDataGrid.Create(Self);
  dgdaSysTypes := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  pCostGroups := TPanel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  dgCostGroups := TTMSFNCDataGrid.Create(Self);
  dgdaCostGroups := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  wpSuppliers := TPanel.Create(Self);
  WebLabel18 := TLabel.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  dgSuppliers := TTMSFNCDataGrid.Create(Self);
  dgdaSuppliers := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  wpVehGroups := TPanel.Create(Self);
  WebLabel20 := TLabel.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  dgVehGroup := TTMSFNCDataGrid.Create(Self);
  dgdaVehGroups := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebButton1 := TButton.Create(Self);
  wpDashSums := TPanel.Create(Self);
  wpTotalCost := TPanel.Create(Self);
  WebDBLabel1 := TDBLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebDBLabel10 := TDBLabel.Create(Self);
  wpMaintenance := TPanel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebDBLabel2 := TDBLabel.Create(Self);
  WebDBLabel11 := TDBLabel.Create(Self);
  wpTyres := TPanel.Create(Self);
  WebDBLabel5 := TDBLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebDBLabel12 := TDBLabel.Create(Self);
  wpCost := TPanel.Create(Self);
  WebDBLabel3 := TDBLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebDBLabel9 := TDBLabel.Create(Self);
  wpInsurance := TPanel.Create(Self);
  WebDBLabel4 := TDBLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebDBLabel13 := TDBLabel.Create(Self);
  wpOperational := TPanel.Create(Self);
  WebDBLabel6 := TDBLabel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebDBLabel14 := TDBLabel.Create(Self);
  wbSearch := TButton.Create(Self);
  wpCapex := TPanel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebDBLabel7 := TDBLabel.Create(Self);
  WebDBLabel15 := TDBLabel.Create(Self);
  wpUnAll := TPanel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebDBLabel8 := TDBLabel.Create(Self);
  WebDBLabel16 := TDBLabel.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebLabel15 := TLabel.Create(Self);
  WebLabel16 := TLabel.Create(Self);
  wbExcel := TButton.Create(Self);
  wpNoLink := TPanel.Create(Self);
  WebLabel17 := TLabel.Create(Self);
  WebDBLabel17 := TDBLabel.Create(Self);
  WebDBLabel18 := TDBLabel.Create(Self);
  pDashData := TPanel.Create(Self);
  dgDashData := TTMSFNCDataGrid.Create(Self);
  dgdaDashData := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebWaitMessage1 := TWaitMessage.Create(Self);
  BitmapContainer1 := TTMSFNCBitmapContainer.Create(Self);
  wcYears := TXDataWebClient.Create(Self);
  wdsYears := TXDataWebDataSet.Create(Self);
  wdsYearsSelected := TBooleanField.Create(Self);
  wdsYearsYear := TIntegerField.Create(Self);
  dsYears := TDataSource.Create(Self);
  wcMonths := TXDataWebClient.Create(Self);
  wdsMonths := TXDataWebDataSet.Create(Self);
  wdsMonthsMonth := TIntegerField.Create(Self);
  wdsMonthsMonthName := TStringField.Create(Self);
  wdsMonthsSelected := TBooleanField.Create(Self);
  dsMonths := TDataSource.Create(Self);
  wcReg := TXDataWebClient.Create(Self);
  wdsReg := TXDataWebDataSet.Create(Self);
  wdsRegReg := TStringField.Create(Self);
  wdsRegFleetNo := TStringField.Create(Self);
  wdsRegFleetType := TStringField.Create(Self);
  wdsRegSelected := TBooleanField.Create(Self);
  wdsRegPriKey := TIntegerField.Create(Self);
  dsReg := TDataSource.Create(Self);
  WebTimer1 := TTimer.Create(Self);
  wdsTempReg := TXDataWebDataSet.Create(Self);
  StringField1 := TStringField.Create(Self);
  StringField2 := TStringField.Create(Self);
  StringField3 := TStringField.Create(Self);
  BooleanField1 := TBooleanField.Create(Self);
  IntegerField1 := TIntegerField.Create(Self);
  dsSysTypes := TDataSource.Create(Self);
  wcSysTypes := TXDataWebClient.Create(Self);
  wdsSysTypes := TXDataWebDataSet.Create(Self);
  wdsSysTypesSelected := TBooleanField.Create(Self);
  wdsSysTypesSysType := TIntegerField.Create(Self);
  wdsSysTypesDescription := TStringField.Create(Self);
  wdsCostGroups := TXDataWebDataSet.Create(Self);
  wdsCostGroupsselected := TBooleanField.Create(Self);
  wdsCostGroupsCost := TIntegerField.Create(Self);
  wdsCostGroupsDescription := TStringField.Create(Self);
  dsCostGroups := TDataSource.Create(Self);
  wcCostGroups := TXDataWebClient.Create(Self);
  wdsDashboardSums := TXDataWebDataSet.Create(Self);
  wdsDashboardSumsMaintenanceCost := TStringField.Create(Self);
  wdsDashboardSumsTyreCost := TStringField.Create(Self);
  wdsDashboardSumsWashCost := TStringField.Create(Self);
  wdsDashboardSumsInsuranceCost := TStringField.Create(Self);
  wdsDashboardSumsOtherCost := TStringField.Create(Self);
  wdsDashboardSumsTotalCost := TStringField.Create(Self);
  wdsDashboardSumsCapexCost := TStringField.Create(Self);
  wdsDashboardSumsUnallCost := TStringField.Create(Self);
  wdsDashboardSumsTotalCPK := TStringField.Create(Self);
  wdsDashboardSumsMaintenanceCPK := TStringField.Create(Self);
  wdsDashboardSumsTyreCPK := TStringField.Create(Self);
  wdsDashboardSumsWashCPK := TStringField.Create(Self);
  wdsDashboardSumsInsuranceCPK := TStringField.Create(Self);
  wdsDashboardSumsOtherCPK := TStringField.Create(Self);
  wdsDashboardSumsCapexCPK := TStringField.Create(Self);
  wdsDashboardSumsUnallCPK := TStringField.Create(Self);
  wdsDashboardSumsNotLinkedCost := TStringField.Create(Self);
  wdsDashboardSumsNotLinkedCPK := TStringField.Create(Self);
  wdsDashData := TXDataWebDataSet.Create(Self);
  wdsDashDataJobcardNo := TIntegerField.Create(Self);
  wdsDashDataStockDescription := TStringField.Create(Self);
  wdsDashDataTotalExcl := TStringField.Create(Self);
  wdsDashDataGlCode := TStringField.Create(Self);
  wdsDashDataReason := TStringField.Create(Self);
  wdsDashDataCategory := TStringField.Create(Self);
  wdsDashDataRepMain := TStringField.Create(Self);
  wdsDashDataCostDescription := TStringField.Create(Self);
  wdsDashDataTRegNo := TStringField.Create(Self);
  wdsDashDataTFleetNo := TStringField.Create(Self);
  wdsDashDataOrderNo := TStringField.Create(Self);
  wdsDashDataJobDate := TStringField.Create(Self);
  wdsDashDataReferenceNo := TStringField.Create(Self);
  wdsDashDataVehType := TStringField.Create(Self);
  wdsDashDataJobType := TStringField.Create(Self);
  wdsDashDataSupplier := TStringField.Create(Self);
  wcDashboardSums := TXDataWebClient.Create(Self);
  dsDashBoardSums := TDataSource.Create(Self);
  wcDashData := TXDataWebClient.Create(Self);
  dsDashData := TDataSource.Create(Self);
  wdsSuppliers := TXDataWebDataSet.Create(Self);
  wdsSuppliersCrName := TStringField.Create(Self);
  wdsSuppliersCrNumber := TStringField.Create(Self);
  wdsSuppliersSelected := TBooleanField.Create(Self);
  wcSuppliers := TXDataWebClient.Create(Self);
  dsSuppliers := TDataSource.Create(Self);
  wdsVehGroups := TXDataWebDataSet.Create(Self);
  wdsVehGroupsSysType := TStringField.Create(Self);
  wdsVehGroupsDescription := TStringField.Create(Self);
  wdsVehGroupsSelected := TBooleanField.Create(Self);
  wcVehGroups := TXDataWebClient.Create(Self);
  dsVehGroups := TDataSource.Create(Self);

  pTop.BeforeLoadDFMValues;
  pBottom.BeforeLoadDFMValues;
  pMain.BeforeLoadDFMValues;
  pMainTop.BeforeLoadDFMValues;
  pMainMonths.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  btnMonthsClear.BeforeLoadDFMValues;
  dgMonths.BeforeLoadDFMValues;
  dgdaMonths.BeforeLoadDFMValues;
  pMainYears.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  btnYearsClear.BeforeLoadDFMValues;
  dgYears.BeforeLoadDFMValues;
  dgdaYears.BeforeLoadDFMValues;
  pRegNo.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  btnRegClear.BeforeLoadDFMValues;
  dgReg.BeforeLoadDFMValues;
  dgdaReg.BeforeLoadDFMValues;
  pMaintTypes.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  dgSysTypes.BeforeLoadDFMValues;
  dgdaSysTypes.BeforeLoadDFMValues;
  pCostGroups.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  dgCostGroups.BeforeLoadDFMValues;
  dgdaCostGroups.BeforeLoadDFMValues;
  wpSuppliers.BeforeLoadDFMValues;
  WebLabel18.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  dgSuppliers.BeforeLoadDFMValues;
  dgdaSuppliers.BeforeLoadDFMValues;
  wpVehGroups.BeforeLoadDFMValues;
  WebLabel20.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  dgVehGroup.BeforeLoadDFMValues;
  dgdaVehGroups.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  wpDashSums.BeforeLoadDFMValues;
  wpTotalCost.BeforeLoadDFMValues;
  WebDBLabel1.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebDBLabel10.BeforeLoadDFMValues;
  wpMaintenance.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebDBLabel2.BeforeLoadDFMValues;
  WebDBLabel11.BeforeLoadDFMValues;
  wpTyres.BeforeLoadDFMValues;
  WebDBLabel5.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebDBLabel12.BeforeLoadDFMValues;
  wpCost.BeforeLoadDFMValues;
  WebDBLabel3.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebDBLabel9.BeforeLoadDFMValues;
  wpInsurance.BeforeLoadDFMValues;
  WebDBLabel4.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebDBLabel13.BeforeLoadDFMValues;
  wpOperational.BeforeLoadDFMValues;
  WebDBLabel6.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebDBLabel14.BeforeLoadDFMValues;
  wbSearch.BeforeLoadDFMValues;
  wpCapex.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebDBLabel7.BeforeLoadDFMValues;
  WebDBLabel15.BeforeLoadDFMValues;
  wpUnAll.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebDBLabel8.BeforeLoadDFMValues;
  WebDBLabel16.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  wbExcel.BeforeLoadDFMValues;
  wpNoLink.BeforeLoadDFMValues;
  WebLabel17.BeforeLoadDFMValues;
  WebDBLabel17.BeforeLoadDFMValues;
  WebDBLabel18.BeforeLoadDFMValues;
  pDashData.BeforeLoadDFMValues;
  dgDashData.BeforeLoadDFMValues;
  dgdaDashData.BeforeLoadDFMValues;
  WebWaitMessage1.BeforeLoadDFMValues;
  BitmapContainer1.BeforeLoadDFMValues;
  wcYears.BeforeLoadDFMValues;
  wdsYears.BeforeLoadDFMValues;
  wdsYearsSelected.BeforeLoadDFMValues;
  wdsYearsYear.BeforeLoadDFMValues;
  dsYears.BeforeLoadDFMValues;
  wcMonths.BeforeLoadDFMValues;
  wdsMonths.BeforeLoadDFMValues;
  wdsMonthsMonth.BeforeLoadDFMValues;
  wdsMonthsMonthName.BeforeLoadDFMValues;
  wdsMonthsSelected.BeforeLoadDFMValues;
  dsMonths.BeforeLoadDFMValues;
  wcReg.BeforeLoadDFMValues;
  wdsReg.BeforeLoadDFMValues;
  wdsRegReg.BeforeLoadDFMValues;
  wdsRegFleetNo.BeforeLoadDFMValues;
  wdsRegFleetType.BeforeLoadDFMValues;
  wdsRegSelected.BeforeLoadDFMValues;
  wdsRegPriKey.BeforeLoadDFMValues;
  dsReg.BeforeLoadDFMValues;
  WebTimer1.BeforeLoadDFMValues;
  wdsTempReg.BeforeLoadDFMValues;
  StringField1.BeforeLoadDFMValues;
  StringField2.BeforeLoadDFMValues;
  StringField3.BeforeLoadDFMValues;
  BooleanField1.BeforeLoadDFMValues;
  IntegerField1.BeforeLoadDFMValues;
  dsSysTypes.BeforeLoadDFMValues;
  wcSysTypes.BeforeLoadDFMValues;
  wdsSysTypes.BeforeLoadDFMValues;
  wdsSysTypesSelected.BeforeLoadDFMValues;
  wdsSysTypesSysType.BeforeLoadDFMValues;
  wdsSysTypesDescription.BeforeLoadDFMValues;
  wdsCostGroups.BeforeLoadDFMValues;
  wdsCostGroupsselected.BeforeLoadDFMValues;
  wdsCostGroupsCost.BeforeLoadDFMValues;
  wdsCostGroupsDescription.BeforeLoadDFMValues;
  dsCostGroups.BeforeLoadDFMValues;
  wcCostGroups.BeforeLoadDFMValues;
  wdsDashboardSums.BeforeLoadDFMValues;
  wdsDashboardSumsMaintenanceCost.BeforeLoadDFMValues;
  wdsDashboardSumsTyreCost.BeforeLoadDFMValues;
  wdsDashboardSumsWashCost.BeforeLoadDFMValues;
  wdsDashboardSumsInsuranceCost.BeforeLoadDFMValues;
  wdsDashboardSumsOtherCost.BeforeLoadDFMValues;
  wdsDashboardSumsTotalCost.BeforeLoadDFMValues;
  wdsDashboardSumsCapexCost.BeforeLoadDFMValues;
  wdsDashboardSumsUnallCost.BeforeLoadDFMValues;
  wdsDashboardSumsTotalCPK.BeforeLoadDFMValues;
  wdsDashboardSumsMaintenanceCPK.BeforeLoadDFMValues;
  wdsDashboardSumsTyreCPK.BeforeLoadDFMValues;
  wdsDashboardSumsWashCPK.BeforeLoadDFMValues;
  wdsDashboardSumsInsuranceCPK.BeforeLoadDFMValues;
  wdsDashboardSumsOtherCPK.BeforeLoadDFMValues;
  wdsDashboardSumsCapexCPK.BeforeLoadDFMValues;
  wdsDashboardSumsUnallCPK.BeforeLoadDFMValues;
  wdsDashboardSumsNotLinkedCost.BeforeLoadDFMValues;
  wdsDashboardSumsNotLinkedCPK.BeforeLoadDFMValues;
  wdsDashData.BeforeLoadDFMValues;
  wdsDashDataJobcardNo.BeforeLoadDFMValues;
  wdsDashDataStockDescription.BeforeLoadDFMValues;
  wdsDashDataTotalExcl.BeforeLoadDFMValues;
  wdsDashDataGlCode.BeforeLoadDFMValues;
  wdsDashDataReason.BeforeLoadDFMValues;
  wdsDashDataCategory.BeforeLoadDFMValues;
  wdsDashDataRepMain.BeforeLoadDFMValues;
  wdsDashDataCostDescription.BeforeLoadDFMValues;
  wdsDashDataTRegNo.BeforeLoadDFMValues;
  wdsDashDataTFleetNo.BeforeLoadDFMValues;
  wdsDashDataOrderNo.BeforeLoadDFMValues;
  wdsDashDataJobDate.BeforeLoadDFMValues;
  wdsDashDataReferenceNo.BeforeLoadDFMValues;
  wdsDashDataVehType.BeforeLoadDFMValues;
  wdsDashDataJobType.BeforeLoadDFMValues;
  wdsDashDataSupplier.BeforeLoadDFMValues;
  wcDashboardSums.BeforeLoadDFMValues;
  dsDashBoardSums.BeforeLoadDFMValues;
  wcDashData.BeforeLoadDFMValues;
  dsDashData.BeforeLoadDFMValues;
  wdsSuppliers.BeforeLoadDFMValues;
  wdsSuppliersCrName.BeforeLoadDFMValues;
  wdsSuppliersCrNumber.BeforeLoadDFMValues;
  wdsSuppliersSelected.BeforeLoadDFMValues;
  wcSuppliers.BeforeLoadDFMValues;
  dsSuppliers.BeforeLoadDFMValues;
  wdsVehGroups.BeforeLoadDFMValues;
  wdsVehGroupsSysType.BeforeLoadDFMValues;
  wdsVehGroupsDescription.BeforeLoadDFMValues;
  wdsVehGroupsSelected.BeforeLoadDFMValues;
  wcVehGroups.BeforeLoadDFMValues;
  dsVehGroups.BeforeLoadDFMValues;
  try
    Name := 'frmDashBoardMaintenance';
    Left := 776;
    Width := 1714;
    Height := 578;
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    pTop.SetParentComponent(Self);
    pTop.Name := 'pTop';
    pTop.Left := 0;
    pTop.Top := 0;
    pTop.Width := 1714;
    pTop.Height := 41;
    pTop.Align := alTop;
    pTop.Caption := 'Maintenance Dashboard';
    pTop.Color := clSkyBlue;
    pTop.Font.Charset := DEFAULT_CHARSET;
    pTop.Font.Color := clWindowText;
    pTop.Font.Height := -12;
    pTop.Font.Name := 'Segoe UI';
    pTop.Font.Style := [fsBold];
    pTop.ParentFont := False;
    pTop.TabOrder := 0;
    pBottom.SetParentComponent(Self);
    pBottom.Name := 'pBottom';
    pBottom.Left := 0;
    pBottom.Top := 538;
    pBottom.Width := 1714;
    pBottom.Height := 40;
    pBottom.Align := alBottom;
    pBottom.ChildOrder := 1;
    pBottom.TabOrder := 1;
    pMain.SetParentComponent(Self);
    pMain.Name := 'pMain';
    pMain.Left := 0;
    pMain.Top := 41;
    pMain.Width := 1714;
    pMain.Height := 497;
    pMain.Align := alClient;
    pMain.ChildOrder := 2;
    pMain.TabOrder := 2;
    pMainTop.SetParentComponent(pMain);
    pMainTop.Name := 'pMainTop';
    pMainTop.Left := 0;
    pMainTop.Top := 0;
    pMainTop.Width := 1714;
    pMainTop.Height := 193;
    pMainTop.Align := alTop;
    pMainTop.BorderStyle := bsNone;
    pMainTop.ChildOrder := 2;
    pMainTop.TabOrder := 0;
    pMainMonths.SetParentComponent(pMainTop);
    pMainMonths.Name := 'pMainMonths';
    pMainMonths.Left := 137;
    pMainMonths.Top := 0;
    pMainMonths.Width := 136;
    pMainMonths.Height := 193;
    pMainMonths.Align := alLeft;
    pMainMonths.ChildOrder := 2;
    pMainMonths.TabOrder := 0;
    WebLabel2.SetParentComponent(pMainMonths);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 0;
    WebLabel2.Top := 0;
    WebLabel2.Width := 136;
    WebLabel2.Height := 15;
    WebLabel2.Align := alTop;
    WebLabel2.Alignment := taCenter;
    WebLabel2.Caption := 'Select Months';
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clWindowText;
    WebLabel2.Font.Height := -12;
    WebLabel2.Font.Name := 'Segoe UI';
    WebLabel2.Font.Style := [fsBold];
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.WidthPercent := 100.000000000000000000;
    btnMonthsClear.SetParentComponent(pMainMonths);
    btnMonthsClear.Name := 'btnMonthsClear';
    btnMonthsClear.Left := 0;
    btnMonthsClear.Top := 163;
    btnMonthsClear.Width := 136;
    btnMonthsClear.Height := 24;
    btnMonthsClear.Align := alBottom;
    btnMonthsClear.Caption := 'Clear';
    btnMonthsClear.Color := clNone;
    btnMonthsClear.HeightPercent := 100.000000000000000000;
    btnMonthsClear.TabOrder := 0;
    btnMonthsClear.WidthPercent := 100.000000000000000000;
    SetEvent(btnMonthsClear, Self, 'OnClick', 'btnMonthsClearClick');
    dgMonths.SetParentComponent(pMainMonths);
    dgMonths.Name := 'dgMonths';
    dgMonths.Left := 0;
    dgMonths.Top := 15;
    dgMonths.Width := 136;
    dgMonths.Height := 148;
    dgMonths.Align := alClient;
    dgMonths.ParentDoubleBuffered := False;
    dgMonths.DoubleBuffered := True;
    dgMonths.TabOrder := 1;
    dgMonths.ShowAcceleratorChar := False;
    dgMonths.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgMonths.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgMonths.Header.VisualGrouping.Layout.Font.Height := -12;
    dgMonths.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgMonths.Header.VisualGrouping.Layout.Font.Style := [];
    dgMonths.Adapter := dgdaMonths;
    dgMonths.BitmapContainer := BitmapContainer1;
    dgMonths.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgMonths.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgMonths.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgMonths.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgMonths.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgMonths.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgMonths.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgMonths.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgMonths.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgMonths.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgMonths.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgMonths.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgMonths.CellAppearance.BandLayout.Font.Height := -12;
    dgMonths.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgMonths.CellAppearance.BandLayout.Font.Style := [];
    dgMonths.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgMonths.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgMonths.CellAppearance.FixedLayout.Font.Height := -12;
    dgMonths.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgMonths.CellAppearance.FixedLayout.Font.Style := [];
    dgMonths.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgMonths.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgMonths.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgMonths.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgMonths.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgMonths.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgMonths.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgMonths.CellAppearance.FocusedLayout.Font.Height := -12;
    dgMonths.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgMonths.CellAppearance.FocusedLayout.Font.Style := [];
    dgMonths.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgMonths.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgMonths.CellAppearance.GroupLayout.Font.Height := -12;
    dgMonths.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgMonths.CellAppearance.GroupLayout.Font.Style := [];
    dgMonths.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgMonths.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgMonths.CellAppearance.NormalLayout.Font.Height := -12;
    dgMonths.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgMonths.CellAppearance.NormalLayout.Font.Style := [];
    dgMonths.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgMonths.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgMonths.CellAppearance.SelectedLayout.Font.Height := -12;
    dgMonths.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgMonths.CellAppearance.SelectedLayout.Font.Style := [];
    dgMonths.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgMonths.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgMonths.CellAppearance.SummaryLayout.Font.Height := -12;
    dgMonths.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgMonths.CellAppearance.SummaryLayout.Font.Style := [];
    dgMonths.Columns.Clear;
    with dgMonths.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Month';
      Width := 50.000000000000000000;
    end;
    with dgMonths.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'MonthNo';
      Width := 0.000000000000000000;
    end;
    with dgMonths.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Status';
      Settings := [gcsType];
      Width := 70.000000000000000000;
    end;
    with dgMonths.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    dgMonths.Designer := False;
    dgMonths.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgMonths.FilterAppearance.Font.Color := clWindowText;
    dgMonths.FilterAppearance.Font.Height := -12;
    dgMonths.FilterAppearance.Font.Name := 'Segoe UI';
    dgMonths.FilterAppearance.Font.Style := [];
    dgMonths.HorizontalScrollBarVisible := False;
    dgMonths.Icons.ExpandIcon.LoadFromFile('dashboard.maintenance.pMainMonths.dgMonths.Icons.ExpandIcon.svg');
    dgMonths.Icons.CollapseIcon.LoadFromFile('dashboard.maintenance.pMainMonths.dgMonths.Icons.CollapseIcon.svg');
    dgMonths.Icons.FilterIcon.LoadFromFile('dashboard.maintenance.pMainMonths.dgMonths.Icons.FilterIcon.svg');
    dgMonths.Icons.FilterActiveIcon.LoadFromFile('dashboard.maintenance.pMainMonths.dgMonths.Icons.FilterActiveIcon.svg');
    dgMonths.Icons.FilterClearIcon.LoadFromFile('dashboard.maintenance.pMainMonths.dgMonths.Icons.FilterClearIcon.svg');
    dgMonths.Icons.FilterTypeIcon.LoadFromFile('dashboard.maintenance.pMainMonths.dgMonths.Icons.FilterTypeIcon.svg');
    dgMonths.Icons.SortAscendingIcon.LoadFromFile('dashboard.maintenance.pMainMonths.dgMonths.Icons.SortAscendingIcon.svg');
    dgMonths.Icons.SortDescendingIcon.LoadFromFile('dashboard.maintenance.pMainMonths.dgMonths.Icons.SortDescendingIcon.svg');
    dgMonths.Icons.CloseIcon.LoadFromFile('dashboard.maintenance.pMainMonths.dgMonths.Icons.CloseIcon.svg');
    SetEvent(dgMonths, Self, 'OnCellClick', 'dgMonthsCellClick');
    SetEvent(dgMonths, Self, 'OnGetCellProperties', 'dgMonthsGetCellProperties');
    dgMonths.RowCount := 1;
    dgdaMonths.SetParentComponent(dgMonths);
    dgdaMonths.Name := 'dgdaMonths';
    dgdaMonths.Left := 104;
    dgdaMonths.Top := 72;
    dgdaMonths.Width := 26;
    dgdaMonths.Height := 26;
    dgdaMonths.Visible := True;
    dgdaMonths.AutoCreateColumns := False;
    dgdaMonths.AutoRemoveColumns := False;
    dgdaMonths.Columns.Clear;
    with dgdaMonths.Columns.Add do
    begin
      FieldName := 'MonthName';
      Header := 'Month';
      AutoCreated := False;
    end;
    with dgdaMonths.Columns.Add do
    begin
      FieldName := 'Month';
      Header := 'MonthNo';
      AutoCreated := False;
    end;
    with dgdaMonths.Columns.Add do
    begin
      FieldName := 'Selected';
      AutoCreated := False;
    end;
    with dgdaMonths.Columns.Add do
    begin
      AutoCreated := False;
    end;
    dgdaMonths.DataSource := dsMonths;
    pMainYears.SetParentComponent(pMainTop);
    pMainYears.Name := 'pMainYears';
    pMainYears.Left := 0;
    pMainYears.Top := 0;
    pMainYears.Width := 137;
    pMainYears.Height := 193;
    pMainYears.Align := alLeft;
    pMainYears.BorderStyle := bsNone;
    pMainYears.ChildOrder := 1;
    pMainYears.TabOrder := 1;
    WebLabel1.SetParentComponent(pMainYears);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 0;
    WebLabel1.Width := 137;
    WebLabel1.Height := 15;
    WebLabel1.Align := alTop;
    WebLabel1.Alignment := taCenter;
    WebLabel1.Caption := 'Select Years';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -12;
    WebLabel1.Font.Name := 'Segoe UI';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    btnYearsClear.SetParentComponent(pMainYears);
    btnYearsClear.Name := 'btnYearsClear';
    btnYearsClear.Left := 0;
    btnYearsClear.Top := 169;
    btnYearsClear.Width := 137;
    btnYearsClear.Height := 24;
    btnYearsClear.Align := alBottom;
    btnYearsClear.Caption := 'Clear';
    btnYearsClear.Color := clNone;
    btnYearsClear.HeightPercent := 100.000000000000000000;
    btnYearsClear.TabOrder := 0;
    btnYearsClear.WidthPercent := 100.000000000000000000;
    SetEvent(btnYearsClear, Self, 'OnClick', 'btnYearsClearClick');
    dgYears.SetParentComponent(pMainYears);
    dgYears.Name := 'dgYears';
    dgYears.Left := 0;
    dgYears.Top := 15;
    dgYears.Width := 137;
    dgYears.Height := 154;
    dgYears.Align := alClient;
    dgYears.ParentDoubleBuffered := False;
    dgYears.DoubleBuffered := True;
    dgYears.TabOrder := 1;
    dgYears.ShowAcceleratorChar := False;
    dgYears.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgYears.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgYears.Header.VisualGrouping.Layout.Font.Height := -12;
    dgYears.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgYears.Header.VisualGrouping.Layout.Font.Style := [];
    dgYears.Adapter := dgdaYears;
    dgYears.BitmapContainer := BitmapContainer1;
    dgYears.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgYears.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgYears.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgYears.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgYears.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgYears.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgYears.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgYears.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgYears.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgYears.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgYears.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgYears.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgYears.CellAppearance.BandLayout.Font.Height := -12;
    dgYears.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgYears.CellAppearance.BandLayout.Font.Style := [];
    dgYears.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgYears.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgYears.CellAppearance.FixedLayout.Font.Height := -12;
    dgYears.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgYears.CellAppearance.FixedLayout.Font.Style := [];
    dgYears.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgYears.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgYears.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgYears.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgYears.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgYears.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgYears.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgYears.CellAppearance.FocusedLayout.Font.Height := -12;
    dgYears.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgYears.CellAppearance.FocusedLayout.Font.Style := [];
    dgYears.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgYears.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgYears.CellAppearance.GroupLayout.Font.Height := -12;
    dgYears.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgYears.CellAppearance.GroupLayout.Font.Style := [];
    dgYears.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgYears.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgYears.CellAppearance.NormalLayout.Font.Height := -12;
    dgYears.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgYears.CellAppearance.NormalLayout.Font.Style := [];
    dgYears.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgYears.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgYears.CellAppearance.SelectedLayout.Font.Height := -12;
    dgYears.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgYears.CellAppearance.SelectedLayout.Font.Style := [];
    dgYears.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgYears.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgYears.CellAppearance.SummaryLayout.Font.Height := -12;
    dgYears.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgYears.CellAppearance.SummaryLayout.Font.Style := [];
    dgYears.ColumnCount := 3;
    dgYears.Columns.Clear;
    with dgYears.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Years';
      Width := 50.000000000000000000;
    end;
    with dgYears.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Status';
      Settings := [gcsType];
      Width := 70.000000000000000000;
    end;
    with dgYears.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsType];
      Width := 0.000000000000000000;
    end;
    dgYears.Designer := False;
    dgYears.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgYears.FilterAppearance.Font.Color := clWindowText;
    dgYears.FilterAppearance.Font.Height := -12;
    dgYears.FilterAppearance.Font.Name := 'Segoe UI';
    dgYears.FilterAppearance.Font.Style := [];
    dgYears.HorizontalScrollBarVisible := False;
    dgYears.Icons.ExpandIcon.LoadFromFile('dashboard.maintenance.pMainYears.dgYears.Icons.ExpandIcon.svg');
    dgYears.Icons.CollapseIcon.LoadFromFile('dashboard.maintenance.pMainYears.dgYears.Icons.CollapseIcon.svg');
    dgYears.Icons.FilterIcon.LoadFromFile('dashboard.maintenance.pMainYears.dgYears.Icons.FilterIcon.svg');
    dgYears.Icons.FilterActiveIcon.LoadFromFile('dashboard.maintenance.pMainYears.dgYears.Icons.FilterActiveIcon.svg');
    dgYears.Icons.FilterClearIcon.LoadFromFile('dashboard.maintenance.pMainYears.dgYears.Icons.FilterClearIcon.svg');
    dgYears.Icons.FilterTypeIcon.LoadFromFile('dashboard.maintenance.pMainYears.dgYears.Icons.FilterTypeIcon.svg');
    dgYears.Icons.SortAscendingIcon.LoadFromFile('dashboard.maintenance.pMainYears.dgYears.Icons.SortAscendingIcon.svg');
    dgYears.Icons.SortDescendingIcon.LoadFromFile('dashboard.maintenance.pMainYears.dgYears.Icons.SortDescendingIcon.svg');
    dgYears.Icons.CloseIcon.LoadFromFile('dashboard.maintenance.pMainYears.dgYears.Icons.CloseIcon.svg');
    SetEvent(dgYears, Self, 'OnCellClick', 'dgYearsCellClick');
    SetEvent(dgYears, Self, 'OnGetCellProperties', 'dgYearsGetCellProperties');
    dgYears.RowCount := 1;
    dgdaYears.SetParentComponent(dgYears);
    dgdaYears.Name := 'dgdaYears';
    dgdaYears.Left := 80;
    dgdaYears.Top := 96;
    dgdaYears.Width := 26;
    dgdaYears.Height := 26;
    dgdaYears.Visible := True;
    dgdaYears.AutoCreateColumns := False;
    dgdaYears.AutoRemoveColumns := False;
    dgdaYears.Columns.Clear;
    with dgdaYears.Columns.Add do
    begin
      FieldName := 'Year';
      Header := 'Years';
      AutoCreated := False;
    end;
    with dgdaYears.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Selected';
      AutoCreated := False;
    end;
    with dgdaYears.Columns.Add do
    begin
      AutoCreated := False;
    end;
    dgdaYears.DataSource := dsYears;
    pRegNo.SetParentComponent(pMainTop);
    pRegNo.Name := 'pRegNo';
    pRegNo.Left := 273;
    pRegNo.Top := 0;
    pRegNo.Width := 250;
    pRegNo.Height := 193;
    pRegNo.Align := alLeft;
    pRegNo.BorderStyle := bsNone;
    pRegNo.ChildOrder := 2;
    pRegNo.TabOrder := 2;
    WebLabel3.SetParentComponent(pRegNo);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 0;
    WebLabel3.Top := 0;
    WebLabel3.Width := 250;
    WebLabel3.Height := 15;
    WebLabel3.Align := alTop;
    WebLabel3.Alignment := taCenter;
    WebLabel3.Caption := 'Select Registration';
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -12;
    WebLabel3.Font.Name := 'Segoe UI';
    WebLabel3.Font.Style := [fsBold];
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthPercent := 100.000000000000000000;
    btnRegClear.SetParentComponent(pRegNo);
    btnRegClear.Name := 'btnRegClear';
    btnRegClear.Left := 0;
    btnRegClear.Top := 169;
    btnRegClear.Width := 250;
    btnRegClear.Height := 24;
    btnRegClear.Align := alBottom;
    btnRegClear.Caption := 'Clear';
    btnRegClear.Color := clNone;
    btnRegClear.HeightPercent := 100.000000000000000000;
    btnRegClear.TabOrder := 0;
    btnRegClear.WidthPercent := 100.000000000000000000;
    SetEvent(btnRegClear, Self, 'OnClick', 'btnRegClearClick');
    dgReg.SetParentComponent(pRegNo);
    dgReg.Name := 'dgReg';
    dgReg.Left := 0;
    dgReg.Top := 15;
    dgReg.Width := 250;
    dgReg.Height := 154;
    dgReg.Align := alClient;
    dgReg.ParentDoubleBuffered := False;
    dgReg.DoubleBuffered := True;
    dgReg.TabOrder := 1;
    dgReg.ShowAcceleratorChar := False;
    dgReg.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgReg.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgReg.Header.VisualGrouping.Layout.Font.Height := -12;
    dgReg.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgReg.Header.VisualGrouping.Layout.Font.Style := [];
    dgReg.Adapter := dgdaReg;
    dgReg.BitmapContainer := BitmapContainer1;
    dgReg.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgReg.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgReg.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgReg.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgReg.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgReg.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgReg.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgReg.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgReg.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgReg.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgReg.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgReg.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgReg.CellAppearance.BandLayout.Font.Height := -12;
    dgReg.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgReg.CellAppearance.BandLayout.Font.Style := [];
    dgReg.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgReg.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgReg.CellAppearance.FixedLayout.Font.Height := -12;
    dgReg.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgReg.CellAppearance.FixedLayout.Font.Style := [];
    dgReg.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgReg.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgReg.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgReg.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgReg.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgReg.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgReg.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgReg.CellAppearance.FocusedLayout.Font.Height := -12;
    dgReg.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgReg.CellAppearance.FocusedLayout.Font.Style := [];
    dgReg.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgReg.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgReg.CellAppearance.GroupLayout.Font.Height := -12;
    dgReg.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgReg.CellAppearance.GroupLayout.Font.Style := [];
    dgReg.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgReg.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgReg.CellAppearance.NormalLayout.Font.Height := -12;
    dgReg.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgReg.CellAppearance.NormalLayout.Font.Style := [];
    dgReg.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgReg.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgReg.CellAppearance.SelectedLayout.Font.Height := -12;
    dgReg.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgReg.CellAppearance.SelectedLayout.Font.Style := [];
    dgReg.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgReg.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgReg.CellAppearance.SummaryLayout.Font.Height := -12;
    dgReg.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgReg.CellAppearance.SummaryLayout.Font.Style := [];
    dgReg.Columns.Clear;
    with dgReg.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Fleet No';
      Width := 80.000000000000000000;
    end;
    with dgReg.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Reg No';
      Width := 100.000000000000000000;
    end;
    with dgReg.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Status';
      Settings := [gcsType];
      Width := 50.000000000000000000;
    end;
    with dgReg.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Visible := False;
      Width := 0.000000000000000000;
    end;
    dgReg.Designer := False;
    dgReg.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgReg.FilterAppearance.Font.Color := clWindowText;
    dgReg.FilterAppearance.Font.Height := -12;
    dgReg.FilterAppearance.Font.Name := 'Segoe UI';
    dgReg.FilterAppearance.Font.Style := [];
    dgReg.Icons.ExpandIcon.LoadFromFile('dashboard.maintenance.pRegNo.dgReg.Icons.ExpandIcon.svg');
    dgReg.Icons.CollapseIcon.LoadFromFile('dashboard.maintenance.pRegNo.dgReg.Icons.CollapseIcon.svg');
    dgReg.Icons.FilterIcon.LoadFromFile('dashboard.maintenance.pRegNo.dgReg.Icons.FilterIcon.svg');
    dgReg.Icons.FilterActiveIcon.LoadFromFile('dashboard.maintenance.pRegNo.dgReg.Icons.FilterActiveIcon.svg');
    dgReg.Icons.FilterClearIcon.LoadFromFile('dashboard.maintenance.pRegNo.dgReg.Icons.FilterClearIcon.svg');
    dgReg.Icons.FilterTypeIcon.LoadFromFile('dashboard.maintenance.pRegNo.dgReg.Icons.FilterTypeIcon.svg');
    dgReg.Icons.SortAscendingIcon.LoadFromFile('dashboard.maintenance.pRegNo.dgReg.Icons.SortAscendingIcon.svg');
    dgReg.Icons.SortDescendingIcon.LoadFromFile('dashboard.maintenance.pRegNo.dgReg.Icons.SortDescendingIcon.svg');
    dgReg.Icons.CloseIcon.LoadFromFile('dashboard.maintenance.pRegNo.dgReg.Icons.CloseIcon.svg');
    SetEvent(dgReg, Self, 'OnCellClick', 'dgRegCellClick');
    SetEvent(dgReg, Self, 'OnGetCellProperties', 'dgRegGetCellProperties');
    dgReg.RowCount := 1;
    dgdaReg.SetParentComponent(dgReg);
    dgdaReg.Name := 'dgdaReg';
    dgdaReg.Left := 88;
    dgdaReg.Top := 96;
    dgdaReg.Width := 26;
    dgdaReg.Height := 26;
    dgdaReg.Visible := True;
    dgdaReg.AutoCreateColumns := False;
    dgdaReg.AutoRemoveColumns := False;
    dgdaReg.Columns.Clear;
    with dgdaReg.Columns.Add do
    begin
      FieldName := 'FleetNo';
      Header := 'Fleet No';
      AutoCreated := False;
    end;
    with dgdaReg.Columns.Add do
    begin
      FieldName := 'Reg';
      Header := 'Reg No';
      AutoCreated := False;
    end;
    with dgdaReg.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Status';
      AutoCreated := False;
    end;
    with dgdaReg.Columns.Add do
    begin
      AutoCreated := False;
    end;
    dgdaReg.DataSource := dsReg;
    pMaintTypes.SetParentComponent(pMainTop);
    pMaintTypes.Name := 'pMaintTypes';
    pMaintTypes.Left := 523;
    pMaintTypes.Top := 0;
    pMaintTypes.Width := 220;
    pMaintTypes.Height := 193;
    pMaintTypes.Align := alLeft;
    pMaintTypes.ChildOrder := 3;
    pMaintTypes.TabOrder := 3;
    WebLabel4.SetParentComponent(pMaintTypes);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 0;
    WebLabel4.Top := 0;
    WebLabel4.Width := 220;
    WebLabel4.Height := 15;
    WebLabel4.Align := alTop;
    WebLabel4.Alignment := taCenter;
    WebLabel4.Caption := 'Select System Type';
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clWindowText;
    WebLabel4.Font.Height := -12;
    WebLabel4.Font.Name := 'Segoe UI';
    WebLabel4.Font.Style := [fsBold];
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.ParentFont := False;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebSpeedButton1.SetParentComponent(pMaintTypes);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 0;
    WebSpeedButton1.Top := 169;
    WebSpeedButton1.Width := 220;
    WebSpeedButton1.Height := 24;
    WebSpeedButton1.Align := alBottom;
    WebSpeedButton1.Caption := 'Clear';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 0;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    dgSysTypes.SetParentComponent(pMaintTypes);
    dgSysTypes.Name := 'dgSysTypes';
    dgSysTypes.Left := 0;
    dgSysTypes.Top := 15;
    dgSysTypes.Width := 220;
    dgSysTypes.Height := 154;
    dgSysTypes.Align := alClient;
    dgSysTypes.ParentDoubleBuffered := False;
    dgSysTypes.DoubleBuffered := True;
    dgSysTypes.TabOrder := 1;
    dgSysTypes.ShowAcceleratorChar := False;
    dgSysTypes.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgSysTypes.Header.VisualGrouping.Layout.Font.Height := -12;
    dgSysTypes.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgSysTypes.Header.VisualGrouping.Layout.Font.Style := [];
    dgSysTypes.Adapter := dgdaSysTypes;
    dgSysTypes.BitmapContainer := BitmapContainer1;
    dgSysTypes.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgSysTypes.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgSysTypes.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgSysTypes.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgSysTypes.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgSysTypes.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgSysTypes.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgSysTypes.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgSysTypes.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgSysTypes.CellAppearance.BandLayout.Font.Height := -12;
    dgSysTypes.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgSysTypes.CellAppearance.BandLayout.Font.Style := [];
    dgSysTypes.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgSysTypes.CellAppearance.FixedLayout.Font.Height := -12;
    dgSysTypes.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgSysTypes.CellAppearance.FixedLayout.Font.Style := [];
    dgSysTypes.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgSysTypes.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgSysTypes.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgSysTypes.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgSysTypes.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgSysTypes.CellAppearance.FocusedLayout.Font.Height := -12;
    dgSysTypes.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgSysTypes.CellAppearance.FocusedLayout.Font.Style := [];
    dgSysTypes.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgSysTypes.CellAppearance.GroupLayout.Font.Height := -12;
    dgSysTypes.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgSysTypes.CellAppearance.GroupLayout.Font.Style := [];
    dgSysTypes.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgSysTypes.CellAppearance.NormalLayout.Font.Height := -12;
    dgSysTypes.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgSysTypes.CellAppearance.NormalLayout.Font.Style := [];
    dgSysTypes.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgSysTypes.CellAppearance.SelectedLayout.Font.Height := -12;
    dgSysTypes.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgSysTypes.CellAppearance.SelectedLayout.Font.Style := [];
    dgSysTypes.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgSysTypes.CellAppearance.SummaryLayout.Font.Height := -12;
    dgSysTypes.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgSysTypes.CellAppearance.SummaryLayout.Font.Style := [];
    dgSysTypes.Columns.Clear;
    with dgSysTypes.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'ID';
      Width := 0.000000000000000000;
    end;
    with dgSysTypes.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Name';
      Width := 140.000000000000000000;
    end;
    with dgSysTypes.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Status';
      Settings := [gcsType];
      Width := 50.000000000000000000;
    end;
    with dgSysTypes.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Visible := False;
      Width := 0.000000000000000000;
    end;
    dgSysTypes.Designer := False;
    dgSysTypes.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgSysTypes.FilterAppearance.Font.Color := clWindowText;
    dgSysTypes.FilterAppearance.Font.Height := -12;
    dgSysTypes.FilterAppearance.Font.Name := 'Segoe UI';
    dgSysTypes.FilterAppearance.Font.Style := [];
    dgSysTypes.Icons.ExpandIcon.LoadFromFile('dashboard.maintenance.pMaintTypes.dgSysTypes.Icons.ExpandIcon.svg');
    dgSysTypes.Icons.CollapseIcon.LoadFromFile('dashboard.maintenance.pMaintTypes.dgSysTypes.Icons.CollapseIcon.svg');
    dgSysTypes.Icons.FilterIcon.LoadFromFile('dashboard.maintenance.pMaintTypes.dgSysTypes.Icons.FilterIcon.svg');
    dgSysTypes.Icons.FilterActiveIcon.LoadFromFile('dashboard.maintenance.pMaintTypes.dgSysTypes.Icons.FilterActiveIcon.svg');
    dgSysTypes.Icons.FilterClearIcon.LoadFromFile('dashboard.maintenance.pMaintTypes.dgSysTypes.Icons.FilterClearIcon.svg');
    dgSysTypes.Icons.FilterTypeIcon.LoadFromFile('dashboard.maintenance.pMaintTypes.dgSysTypes.Icons.FilterTypeIcon.svg');
    dgSysTypes.Icons.SortAscendingIcon.LoadFromFile('dashboard.maintenance.pMaintTypes.dgSysTypes.Icons.SortAscendingIcon.svg');
    dgSysTypes.Icons.SortDescendingIcon.LoadFromFile('dashboard.maintenance.pMaintTypes.dgSysTypes.Icons.SortDescendingIcon.svg');
    dgSysTypes.Icons.CloseIcon.LoadFromFile('dashboard.maintenance.pMaintTypes.dgSysTypes.Icons.CloseIcon.svg');
    SetEvent(dgSysTypes, Self, 'OnCellClick', 'dgSysTypesCellClick');
    SetEvent(dgSysTypes, Self, 'OnGetCellProperties', 'dgSysTypesGetCellProperties');
    dgSysTypes.RowCount := 1;
    dgdaSysTypes.SetParentComponent(dgSysTypes);
    dgdaSysTypes.Name := 'dgdaSysTypes';
    dgdaSysTypes.Left := 120;
    dgdaSysTypes.Top := 56;
    dgdaSysTypes.Width := 26;
    dgdaSysTypes.Height := 26;
    dgdaSysTypes.Visible := True;
    dgdaSysTypes.AutoCreateColumns := False;
    dgdaSysTypes.AutoRemoveColumns := False;
    dgdaSysTypes.Columns.Clear;
    with dgdaSysTypes.Columns.Add do
    begin
      FieldName := 'SysType';
      Header := 'ID';
      AutoCreated := False;
    end;
    with dgdaSysTypes.Columns.Add do
    begin
      FieldName := 'Description';
      Header := 'Name';
      AutoCreated := False;
    end;
    with dgdaSysTypes.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Status';
      AutoCreated := False;
    end;
    with dgdaSysTypes.Columns.Add do
    begin
      AutoCreated := False;
    end;
    dgdaSysTypes.DataSource := dsSysTypes;
    pCostGroups.SetParentComponent(pMainTop);
    pCostGroups.Name := 'pCostGroups';
    pCostGroups.Left := 743;
    pCostGroups.Top := 0;
    pCostGroups.Width := 220;
    pCostGroups.Height := 193;
    pCostGroups.Align := alLeft;
    pCostGroups.ChildOrder := 4;
    pCostGroups.TabOrder := 4;
    WebLabel5.SetParentComponent(pCostGroups);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 0;
    WebLabel5.Top := 0;
    WebLabel5.Width := 220;
    WebLabel5.Height := 15;
    WebLabel5.Align := alTop;
    WebLabel5.Alignment := taCenter;
    WebLabel5.Caption := 'Cost Groups';
    WebLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLabel5.Font.Color := clWindowText;
    WebLabel5.Font.Height := -12;
    WebLabel5.Font.Name := 'Segoe UI';
    WebLabel5.Font.Style := [fsBold];
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.ParentFont := False;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebSpeedButton2.SetParentComponent(pCostGroups);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 0;
    WebSpeedButton2.Top := 169;
    WebSpeedButton2.Width := 220;
    WebSpeedButton2.Height := 24;
    WebSpeedButton2.Align := alBottom;
    WebSpeedButton2.Caption := 'Clear';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 0;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    dgCostGroups.SetParentComponent(pCostGroups);
    dgCostGroups.Name := 'dgCostGroups';
    dgCostGroups.Left := 0;
    dgCostGroups.Top := 15;
    dgCostGroups.Width := 220;
    dgCostGroups.Height := 154;
    dgCostGroups.Align := alClient;
    dgCostGroups.ParentDoubleBuffered := False;
    dgCostGroups.DoubleBuffered := True;
    dgCostGroups.TabOrder := 1;
    dgCostGroups.ShowAcceleratorChar := False;
    dgCostGroups.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgCostGroups.Header.VisualGrouping.Layout.Font.Height := -12;
    dgCostGroups.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgCostGroups.Header.VisualGrouping.Layout.Font.Style := [];
    dgCostGroups.Adapter := dgdaCostGroups;
    dgCostGroups.BitmapContainer := BitmapContainer1;
    dgCostGroups.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgCostGroups.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgCostGroups.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgCostGroups.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgCostGroups.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgCostGroups.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgCostGroups.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgCostGroups.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgCostGroups.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgCostGroups.CellAppearance.BandLayout.Font.Height := -12;
    dgCostGroups.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgCostGroups.CellAppearance.BandLayout.Font.Style := [];
    dgCostGroups.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgCostGroups.CellAppearance.FixedLayout.Font.Height := -12;
    dgCostGroups.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgCostGroups.CellAppearance.FixedLayout.Font.Style := [];
    dgCostGroups.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgCostGroups.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgCostGroups.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgCostGroups.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgCostGroups.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgCostGroups.CellAppearance.FocusedLayout.Font.Height := -12;
    dgCostGroups.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgCostGroups.CellAppearance.FocusedLayout.Font.Style := [];
    dgCostGroups.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgCostGroups.CellAppearance.GroupLayout.Font.Height := -12;
    dgCostGroups.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgCostGroups.CellAppearance.GroupLayout.Font.Style := [];
    dgCostGroups.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgCostGroups.CellAppearance.NormalLayout.Font.Height := -12;
    dgCostGroups.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgCostGroups.CellAppearance.NormalLayout.Font.Style := [];
    dgCostGroups.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgCostGroups.CellAppearance.SelectedLayout.Font.Height := -12;
    dgCostGroups.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgCostGroups.CellAppearance.SelectedLayout.Font.Style := [];
    dgCostGroups.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgCostGroups.CellAppearance.SummaryLayout.Font.Height := -12;
    dgCostGroups.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgCostGroups.CellAppearance.SummaryLayout.Font.Style := [];
    dgCostGroups.Columns.Clear;
    with dgCostGroups.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'ID';
      Width := 0.000000000000000000;
    end;
    with dgCostGroups.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Name';
      Width := 140.000000000000000000;
    end;
    with dgCostGroups.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Status';
      Settings := [gcsType];
      Width := 50.000000000000000000;
    end;
    with dgCostGroups.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    dgCostGroups.Designer := False;
    dgCostGroups.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgCostGroups.FilterAppearance.Font.Color := clWindowText;
    dgCostGroups.FilterAppearance.Font.Height := -12;
    dgCostGroups.FilterAppearance.Font.Name := 'Segoe UI';
    dgCostGroups.FilterAppearance.Font.Style := [];
    dgCostGroups.Icons.ExpandIcon.LoadFromFile('dashboard.maintenance.pCostGroups.dgCostGroups.Icons.ExpandIcon.svg');
    dgCostGroups.Icons.CollapseIcon.LoadFromFile('dashboard.maintenance.pCostGroups.dgCostGroups.Icons.CollapseIcon.svg');
    dgCostGroups.Icons.FilterIcon.LoadFromFile('dashboard.maintenance.pCostGroups.dgCostGroups.Icons.FilterIcon.svg');
    dgCostGroups.Icons.FilterActiveIcon.LoadFromFile('dashboard.maintenance.pCostGroups.dgCostGroups.Icons.FilterActiveIcon.svg');
    dgCostGroups.Icons.FilterClearIcon.LoadFromFile('dashboard.maintenance.pCostGroups.dgCostGroups.Icons.FilterClearIcon.svg');
    dgCostGroups.Icons.FilterTypeIcon.LoadFromFile('dashboard.maintenance.pCostGroups.dgCostGroups.Icons.FilterTypeIcon.svg');
    dgCostGroups.Icons.SortAscendingIcon.LoadFromFile('dashboard.maintenance.pCostGroups.dgCostGroups.Icons.SortAscendingIcon.svg');
    dgCostGroups.Icons.SortDescendingIcon.LoadFromFile('dashboard.maintenance.pCostGroups.dgCostGroups.Icons.SortDescendingIcon.svg');
    dgCostGroups.Icons.CloseIcon.LoadFromFile('dashboard.maintenance.pCostGroups.dgCostGroups.Icons.CloseIcon.svg');
    SetEvent(dgCostGroups, Self, 'OnCellClick', 'dgCostGroupsCellClick');
    SetEvent(dgCostGroups, Self, 'OnGetCellProperties', 'dgCostGroupsGetCellProperties');
    dgCostGroups.RowCount := 1;
    dgdaCostGroups.SetParentComponent(dgCostGroups);
    dgdaCostGroups.Name := 'dgdaCostGroups';
    dgdaCostGroups.Left := 104;
    dgdaCostGroups.Top := 64;
    dgdaCostGroups.Width := 26;
    dgdaCostGroups.Height := 26;
    dgdaCostGroups.Visible := True;
    dgdaCostGroups.AutoCreateColumns := False;
    dgdaCostGroups.AutoRemoveColumns := False;
    dgdaCostGroups.Columns.Clear;
    with dgdaCostGroups.Columns.Add do
    begin
      FieldName := 'Cost';
      Header := 'ID';
      AutoCreated := False;
    end;
    with dgdaCostGroups.Columns.Add do
    begin
      FieldName := 'Description';
      Header := 'Name';
      AutoCreated := False;
    end;
    with dgdaCostGroups.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Selected';
      AutoCreated := False;
    end;
    with dgdaCostGroups.Columns.Add do
    begin
      AutoCreated := False;
    end;
    dgdaCostGroups.DataSource := dsCostGroups;
    wpSuppliers.SetParentComponent(pMainTop);
    wpSuppliers.Name := 'wpSuppliers';
    wpSuppliers.Left := 963;
    wpSuppliers.Top := 0;
    wpSuppliers.Width := 248;
    wpSuppliers.Height := 193;
    wpSuppliers.Align := alLeft;
    wpSuppliers.ChildOrder := 6;
    wpSuppliers.TabOrder := 5;
    WebLabel18.SetParentComponent(wpSuppliers);
    WebLabel18.Name := 'WebLabel18';
    WebLabel18.Left := 0;
    WebLabel18.Top := 0;
    WebLabel18.Width := 248;
    WebLabel18.Height := 15;
    WebLabel18.Align := alTop;
    WebLabel18.Alignment := taCenter;
    WebLabel18.Caption := 'Suppliers';
    WebLabel18.Font.Charset := DEFAULT_CHARSET;
    WebLabel18.Font.Color := clWindowText;
    WebLabel18.Font.Height := -12;
    WebLabel18.Font.Name := 'Segoe UI';
    WebLabel18.Font.Style := [fsBold];
    WebLabel18.HeightPercent := 100.000000000000000000;
    WebLabel18.ParentFont := False;
    WebLabel18.WidthPercent := 100.000000000000000000;
    WebSpeedButton3.SetParentComponent(wpSuppliers);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 0;
    WebSpeedButton3.Top := 169;
    WebSpeedButton3.Width := 248;
    WebSpeedButton3.Height := 24;
    WebSpeedButton3.Align := alBottom;
    WebSpeedButton3.Caption := 'Clear';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.TabOrder := 0;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton3, Self, 'OnClick', 'WebSpeedButton3Click');
    dgSuppliers.SetParentComponent(wpSuppliers);
    dgSuppliers.Name := 'dgSuppliers';
    dgSuppliers.Left := 0;
    dgSuppliers.Top := 15;
    dgSuppliers.Width := 248;
    dgSuppliers.Height := 154;
    dgSuppliers.Align := alClient;
    dgSuppliers.ParentDoubleBuffered := False;
    dgSuppliers.DoubleBuffered := True;
    dgSuppliers.TabOrder := 1;
    dgSuppliers.ShowAcceleratorChar := False;
    dgSuppliers.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgSuppliers.Header.VisualGrouping.Layout.Font.Height := -12;
    dgSuppliers.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgSuppliers.Header.VisualGrouping.Layout.Font.Style := [];
    dgSuppliers.Adapter := dgdaSuppliers;
    dgSuppliers.BitmapContainer := BitmapContainer1;
    dgSuppliers.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgSuppliers.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgSuppliers.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgSuppliers.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgSuppliers.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgSuppliers.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgSuppliers.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgSuppliers.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgSuppliers.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgSuppliers.CellAppearance.BandLayout.Font.Height := -12;
    dgSuppliers.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgSuppliers.CellAppearance.BandLayout.Font.Style := [];
    dgSuppliers.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgSuppliers.CellAppearance.FixedLayout.Font.Height := -12;
    dgSuppliers.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgSuppliers.CellAppearance.FixedLayout.Font.Style := [];
    dgSuppliers.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgSuppliers.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgSuppliers.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgSuppliers.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgSuppliers.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgSuppliers.CellAppearance.FocusedLayout.Font.Height := -12;
    dgSuppliers.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgSuppliers.CellAppearance.FocusedLayout.Font.Style := [];
    dgSuppliers.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgSuppliers.CellAppearance.GroupLayout.Font.Height := -12;
    dgSuppliers.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgSuppliers.CellAppearance.GroupLayout.Font.Style := [];
    dgSuppliers.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgSuppliers.CellAppearance.NormalLayout.Font.Height := -12;
    dgSuppliers.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgSuppliers.CellAppearance.NormalLayout.Font.Style := [];
    dgSuppliers.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgSuppliers.CellAppearance.SelectedLayout.Font.Height := -12;
    dgSuppliers.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgSuppliers.CellAppearance.SelectedLayout.Font.Style := [];
    dgSuppliers.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgSuppliers.CellAppearance.SummaryLayout.Font.Height := -12;
    dgSuppliers.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgSuppliers.CellAppearance.SummaryLayout.Font.Style := [];
    dgSuppliers.Columns.Clear;
    with dgSuppliers.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Code';
      Width := 0.000000000000000000;
    end;
    with dgSuppliers.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Name';
      Width := 150.000000000000000000;
    end;
    with dgSuppliers.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Status';
      Settings := [gcsType];
    end;
    with dgSuppliers.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    dgSuppliers.Designer := False;
    dgSuppliers.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgSuppliers.FilterAppearance.Font.Color := clWindowText;
    dgSuppliers.FilterAppearance.Font.Height := -12;
    dgSuppliers.FilterAppearance.Font.Name := 'Segoe UI';
    dgSuppliers.FilterAppearance.Font.Style := [];
    dgSuppliers.Icons.ExpandIcon.LoadFromFile('dashboard.maintenance.wpSuppliers.dgSuppliers.Icons.ExpandIcon.svg');
    dgSuppliers.Icons.CollapseIcon.LoadFromFile('dashboard.maintenance.wpSuppliers.dgSuppliers.Icons.CollapseIcon.svg');
    dgSuppliers.Icons.FilterIcon.LoadFromFile('dashboard.maintenance.wpSuppliers.dgSuppliers.Icons.FilterIcon.svg');
    dgSuppliers.Icons.FilterActiveIcon.LoadFromFile('dashboard.maintenance.wpSuppliers.dgSuppliers.Icons.FilterActiveIcon.svg');
    dgSuppliers.Icons.FilterClearIcon.LoadFromFile('dashboard.maintenance.wpSuppliers.dgSuppliers.Icons.FilterClearIcon.svg');
    dgSuppliers.Icons.FilterTypeIcon.LoadFromFile('dashboard.maintenance.wpSuppliers.dgSuppliers.Icons.FilterTypeIcon.svg');
    dgSuppliers.Icons.SortAscendingIcon.LoadFromFile('dashboard.maintenance.wpSuppliers.dgSuppliers.Icons.SortAscendingIcon.svg');
    dgSuppliers.Icons.SortDescendingIcon.LoadFromFile('dashboard.maintenance.wpSuppliers.dgSuppliers.Icons.SortDescendingIcon.svg');
    dgSuppliers.Icons.CloseIcon.LoadFromFile('dashboard.maintenance.wpSuppliers.dgSuppliers.Icons.CloseIcon.svg');
    SetEvent(dgSuppliers, Self, 'OnCellClick', 'dgSuppliersCellClick');
    SetEvent(dgSuppliers, Self, 'OnGetCellProperties', 'dgSuppliersGetCellProperties');
    dgSuppliers.RowCount := 1;
    dgdaSuppliers.SetParentComponent(dgSuppliers);
    dgdaSuppliers.Name := 'dgdaSuppliers';
    dgdaSuppliers.Left := 96;
    dgdaSuppliers.Top := 64;
    dgdaSuppliers.Width := 26;
    dgdaSuppliers.Height := 26;
    dgdaSuppliers.Visible := True;
    dgdaSuppliers.AutoCreateColumns := False;
    dgdaSuppliers.AutoRemoveColumns := False;
    dgdaSuppliers.Columns.Clear;
    with dgdaSuppliers.Columns.Add do
    begin
      FieldName := 'CrNumber';
      Header := 'Code';
      AutoCreated := False;
    end;
    with dgdaSuppliers.Columns.Add do
    begin
      FieldName := 'CrName';
      Header := 'Name';
      AutoCreated := False;
    end;
    with dgdaSuppliers.Columns.Add do
    begin
      FieldName := 'Selected';
      AutoCreated := False;
    end;
    with dgdaSuppliers.Columns.Add do
    begin
      AutoCreated := False;
    end;
    dgdaSuppliers.DataSource := dsSuppliers;
    wpVehGroups.SetParentComponent(pMainTop);
    wpVehGroups.Name := 'wpVehGroups';
    wpVehGroups.Left := 1211;
    wpVehGroups.Top := 0;
    wpVehGroups.Width := 197;
    wpVehGroups.Height := 193;
    wpVehGroups.Align := alLeft;
    wpVehGroups.ChildOrder := 1;
    wpVehGroups.TabOrder := 6;
    WebLabel20.SetParentComponent(wpVehGroups);
    WebLabel20.Name := 'WebLabel20';
    WebLabel20.Left := 0;
    WebLabel20.Top := 0;
    WebLabel20.Width := 197;
    WebLabel20.Height := 15;
    WebLabel20.Align := alTop;
    WebLabel20.Alignment := taCenter;
    WebLabel20.Caption := 'Vehicle Groups';
    WebLabel20.Font.Charset := DEFAULT_CHARSET;
    WebLabel20.Font.Color := clWindowText;
    WebLabel20.Font.Height := -12;
    WebLabel20.Font.Name := 'Segoe UI';
    WebLabel20.Font.Style := [fsBold];
    WebLabel20.HeightPercent := 100.000000000000000000;
    WebLabel20.ParentFont := False;
    WebLabel20.WidthPercent := 100.000000000000000000;
    WebSpeedButton5.SetParentComponent(wpVehGroups);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 0;
    WebSpeedButton5.Top := 169;
    WebSpeedButton5.Width := 197;
    WebSpeedButton5.Height := 24;
    WebSpeedButton5.Align := alBottom;
    WebSpeedButton5.Caption := 'Clear';
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.TabOrder := 0;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
    dgVehGroup.SetParentComponent(wpVehGroups);
    dgVehGroup.Name := 'dgVehGroup';
    dgVehGroup.Left := 0;
    dgVehGroup.Top := 15;
    dgVehGroup.Width := 197;
    dgVehGroup.Height := 154;
    dgVehGroup.Align := alClient;
    dgVehGroup.ParentDoubleBuffered := False;
    dgVehGroup.DoubleBuffered := True;
    dgVehGroup.TabOrder := 1;
    dgVehGroup.ShowAcceleratorChar := False;
    dgVehGroup.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgVehGroup.Header.VisualGrouping.Layout.Font.Height := -12;
    dgVehGroup.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgVehGroup.Header.VisualGrouping.Layout.Font.Style := [];
    dgVehGroup.Adapter := dgdaVehGroups;
    dgVehGroup.BitmapContainer := BitmapContainer1;
    dgVehGroup.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgVehGroup.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgVehGroup.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgVehGroup.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgVehGroup.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgVehGroup.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgVehGroup.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgVehGroup.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgVehGroup.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgVehGroup.CellAppearance.BandLayout.Font.Height := -12;
    dgVehGroup.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgVehGroup.CellAppearance.BandLayout.Font.Style := [];
    dgVehGroup.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgVehGroup.CellAppearance.FixedLayout.Font.Height := -12;
    dgVehGroup.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgVehGroup.CellAppearance.FixedLayout.Font.Style := [];
    dgVehGroup.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgVehGroup.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgVehGroup.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgVehGroup.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgVehGroup.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgVehGroup.CellAppearance.FocusedLayout.Font.Height := -12;
    dgVehGroup.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgVehGroup.CellAppearance.FocusedLayout.Font.Style := [];
    dgVehGroup.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgVehGroup.CellAppearance.GroupLayout.Font.Height := -12;
    dgVehGroup.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgVehGroup.CellAppearance.GroupLayout.Font.Style := [];
    dgVehGroup.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgVehGroup.CellAppearance.NormalLayout.Font.Height := -12;
    dgVehGroup.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgVehGroup.CellAppearance.NormalLayout.Font.Style := [];
    dgVehGroup.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgVehGroup.CellAppearance.SelectedLayout.Font.Height := -12;
    dgVehGroup.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgVehGroup.CellAppearance.SelectedLayout.Font.Style := [];
    dgVehGroup.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgVehGroup.CellAppearance.SummaryLayout.Font.Height := -12;
    dgVehGroup.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgVehGroup.CellAppearance.SummaryLayout.Font.Style := [];
    dgVehGroup.Columns.Clear;
    with dgVehGroup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'ID';
      Width := 0.000000000000000000;
    end;
    with dgVehGroup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Name';
      Width := 100.000000000000000000;
    end;
    with dgVehGroup.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Status';
      Settings := [gcsType];
    end;
    with dgVehGroup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    dgVehGroup.Designer := False;
    dgVehGroup.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgVehGroup.FilterAppearance.Font.Color := clWindowText;
    dgVehGroup.FilterAppearance.Font.Height := -12;
    dgVehGroup.FilterAppearance.Font.Name := 'Segoe UI';
    dgVehGroup.FilterAppearance.Font.Style := [];
    dgVehGroup.Icons.ExpandIcon.LoadFromFile('dashboard.maintenance.wpVehGroups.dgVehGroup.Icons.ExpandIcon.svg');
    dgVehGroup.Icons.CollapseIcon.LoadFromFile('dashboard.maintenance.wpVehGroups.dgVehGroup.Icons.CollapseIcon.svg');
    dgVehGroup.Icons.FilterIcon.LoadFromFile('dashboard.maintenance.wpVehGroups.dgVehGroup.Icons.FilterIcon.svg');
    dgVehGroup.Icons.FilterActiveIcon.LoadFromFile('dashboard.maintenance.wpVehGroups.dgVehGroup.Icons.FilterActiveIcon.svg');
    dgVehGroup.Icons.FilterClearIcon.LoadFromFile('dashboard.maintenance.wpVehGroups.dgVehGroup.Icons.FilterClearIcon.svg');
    dgVehGroup.Icons.FilterTypeIcon.LoadFromFile('dashboard.maintenance.wpVehGroups.dgVehGroup.Icons.FilterTypeIcon.svg');
    dgVehGroup.Icons.SortAscendingIcon.LoadFromFile('dashboard.maintenance.wpVehGroups.dgVehGroup.Icons.SortAscendingIcon.svg');
    dgVehGroup.Icons.SortDescendingIcon.LoadFromFile('dashboard.maintenance.wpVehGroups.dgVehGroup.Icons.SortDescendingIcon.svg');
    dgVehGroup.Icons.CloseIcon.LoadFromFile('dashboard.maintenance.wpVehGroups.dgVehGroup.Icons.CloseIcon.svg');
    SetEvent(dgVehGroup, Self, 'OnCellClick', 'dgVehGroupCellClick');
    SetEvent(dgVehGroup, Self, 'OnGetCellProperties', 'dgVehGroupGetCellProperties');
    dgVehGroup.RowCount := 1;
    dgdaVehGroups.SetParentComponent(dgVehGroup);
    dgdaVehGroups.Name := 'dgdaVehGroups';
    dgdaVehGroups.Left := 144;
    dgdaVehGroups.Top := 32;
    dgdaVehGroups.Width := 26;
    dgdaVehGroups.Height := 26;
    dgdaVehGroups.Visible := True;
    dgdaVehGroups.AutoCreateColumns := False;
    dgdaVehGroups.AutoRemoveColumns := False;
    dgdaVehGroups.Columns.Clear;
    with dgdaVehGroups.Columns.Add do
    begin
      FieldName := 'SysType';
      Header := 'ID';
      AutoCreated := False;
    end;
    with dgdaVehGroups.Columns.Add do
    begin
      FieldName := 'Description';
      Header := 'Name';
      AutoCreated := False;
    end;
    with dgdaVehGroups.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Status';
      AutoCreated := False;
    end;
    with dgdaVehGroups.Columns.Add do
    begin
      AutoCreated := False;
    end;
    dgdaVehGroups.DataSource := dsVehGroups;
    WebButton1.SetParentComponent(pMain);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 1226;
    WebButton1.Top := 466;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'WebButton1';
    WebButton1.ChildOrder := 1;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    wpDashSums.SetParentComponent(pMain);
    wpDashSums.Name := 'wpDashSums';
    wpDashSums.Left := 0;
    wpDashSums.Top := 193;
    wpDashSums.Width := 1714;
    wpDashSums.Height := 72;
    wpDashSums.Align := alTop;
    wpDashSums.ChildOrder := 2;
    wpDashSums.TabOrder := 2;
    wpTotalCost.SetParentComponent(wpDashSums);
    wpTotalCost.Name := 'wpTotalCost';
    wpTotalCost.Left := 57;
    wpTotalCost.Top := 0;
    wpTotalCost.Width := 150;
    wpTotalCost.Height := 72;
    wpTotalCost.Align := alLeft;
    wpTotalCost.BorderColor := clBlack;
    wpTotalCost.ChildOrder := 6;
    wpTotalCost.Color := clYellow;
    wpTotalCost.TabOrder := 0;
    WebDBLabel1.SetParentComponent(wpTotalCost);
    WebDBLabel1.Name := 'WebDBLabel1';
    WebDBLabel1.Left := 0;
    WebDBLabel1.Top := 23;
    WebDBLabel1.Width := 150;
    WebDBLabel1.Height := 23;
    WebDBLabel1.Align := alTop;
    WebDBLabel1.Alignment := taCenter;
    WebDBLabel1.Color := clYellow;
    WebDBLabel1.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel1.Font.Color := clWindowText;
    WebDBLabel1.Font.Height := -17;
    WebDBLabel1.Font.Name := 'Segoe UI';
    WebDBLabel1.Font.Style := [fsBold];
    WebDBLabel1.HeightPercent := 100.000000000000000000;
    WebDBLabel1.ParentFont := False;
    WebDBLabel1.Transparent := False;
    WebDBLabel1.WidthPercent := 100.000000000000000000;
    WebDBLabel1.DataField := 'TotalCost';
    WebDBLabel1.DataSource := dsDashBoardSums;
    WebLabel6.SetParentComponent(wpTotalCost);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 0;
    WebLabel6.Top := 0;
    WebLabel6.Width := 150;
    WebLabel6.Height := 23;
    WebLabel6.Align := alTop;
    WebLabel6.Alignment := taCenter;
    WebLabel6.Caption := 'Total';
    WebLabel6.Font.Charset := DEFAULT_CHARSET;
    WebLabel6.Font.Color := clWindowText;
    WebLabel6.Font.Height := -17;
    WebLabel6.Font.Name := 'Segoe UI';
    WebLabel6.Font.Style := [fsBold];
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.ParentFont := False;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebDBLabel10.SetParentComponent(wpTotalCost);
    WebDBLabel10.Name := 'WebDBLabel10';
    WebDBLabel10.Left := 0;
    WebDBLabel10.Top := 46;
    WebDBLabel10.Width := 150;
    WebDBLabel10.Height := 26;
    WebDBLabel10.Align := alClient;
    WebDBLabel10.Alignment := taCenter;
    WebDBLabel10.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel10.Font.Color := clWindowText;
    WebDBLabel10.Font.Height := -16;
    WebDBLabel10.Font.Name := 'Segoe UI';
    WebDBLabel10.Font.Style := [fsBold];
    WebDBLabel10.HeightPercent := 100.000000000000000000;
    WebDBLabel10.ParentFont := False;
    WebDBLabel10.WidthPercent := 100.000000000000000000;
    WebDBLabel10.DataField := 'TotalCPK';
    WebDBLabel10.DataSource := dsDashBoardSums;
    wpMaintenance.SetParentComponent(wpDashSums);
    wpMaintenance.Name := 'wpMaintenance';
    wpMaintenance.Left := 207;
    wpMaintenance.Top := 0;
    wpMaintenance.Width := 150;
    wpMaintenance.Height := 72;
    wpMaintenance.Align := alLeft;
    wpMaintenance.ChildOrder := 6;
    wpMaintenance.Color := clTomato;
    wpMaintenance.TabOrder := 1;
    WebLabel7.SetParentComponent(wpMaintenance);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 0;
    WebLabel7.Top := 0;
    WebLabel7.Width := 150;
    WebLabel7.Height := 23;
    WebLabel7.Align := alTop;
    WebLabel7.Alignment := taCenter;
    WebLabel7.Caption := 'Maintenance';
    WebLabel7.Font.Charset := DEFAULT_CHARSET;
    WebLabel7.Font.Color := clWindowText;
    WebLabel7.Font.Height := -17;
    WebLabel7.Font.Name := 'Segoe UI';
    WebLabel7.Font.Style := [fsBold];
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.ParentFont := False;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebDBLabel2.SetParentComponent(wpMaintenance);
    WebDBLabel2.Name := 'WebDBLabel2';
    WebDBLabel2.Left := 0;
    WebDBLabel2.Top := 23;
    WebDBLabel2.Width := 150;
    WebDBLabel2.Height := 23;
    WebDBLabel2.Align := alTop;
    WebDBLabel2.Alignment := taCenter;
    WebDBLabel2.Color := clTomato;
    WebDBLabel2.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel2.Font.Color := clWindowText;
    WebDBLabel2.Font.Height := -17;
    WebDBLabel2.Font.Name := 'Segoe UI';
    WebDBLabel2.Font.Style := [fsBold];
    WebDBLabel2.HeightPercent := 100.000000000000000000;
    WebDBLabel2.ParentFont := False;
    WebDBLabel2.Transparent := False;
    WebDBLabel2.WidthPercent := 100.000000000000000000;
    WebDBLabel2.DataField := 'MaintenanceCost';
    WebDBLabel2.DataSource := dsDashBoardSums;
    WebDBLabel11.SetParentComponent(wpMaintenance);
    WebDBLabel11.Name := 'WebDBLabel11';
    WebDBLabel11.Left := 0;
    WebDBLabel11.Top := 46;
    WebDBLabel11.Width := 150;
    WebDBLabel11.Height := 26;
    WebDBLabel11.Align := alClient;
    WebDBLabel11.Alignment := taCenter;
    WebDBLabel11.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel11.Font.Color := clWindowText;
    WebDBLabel11.Font.Height := -16;
    WebDBLabel11.Font.Name := 'Segoe UI';
    WebDBLabel11.Font.Style := [fsBold];
    WebDBLabel11.HeightPercent := 100.000000000000000000;
    WebDBLabel11.ParentFont := False;
    WebDBLabel11.WidthPercent := 100.000000000000000000;
    WebDBLabel11.DataField := 'MaintenanceCPK';
    WebDBLabel11.DataSource := dsDashBoardSums;
    wpTyres.SetParentComponent(wpDashSums);
    wpTyres.Name := 'wpTyres';
    wpTyres.Left := 357;
    wpTyres.Top := 0;
    wpTyres.Width := 150;
    wpTyres.Height := 72;
    wpTyres.Align := alLeft;
    wpTyres.BorderColor := clAqua;
    wpTyres.ChildOrder := 6;
    wpTyres.Color := clAqua;
    wpTyres.TabOrder := 2;
    WebDBLabel5.SetParentComponent(wpTyres);
    WebDBLabel5.Name := 'WebDBLabel5';
    WebDBLabel5.Left := 0;
    WebDBLabel5.Top := 23;
    WebDBLabel5.Width := 150;
    WebDBLabel5.Height := 23;
    WebDBLabel5.Align := alTop;
    WebDBLabel5.Alignment := taCenter;
    WebDBLabel5.Color := clAqua;
    WebDBLabel5.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel5.Font.Color := clWindowText;
    WebDBLabel5.Font.Height := -17;
    WebDBLabel5.Font.Name := 'Segoe UI';
    WebDBLabel5.Font.Style := [fsBold];
    WebDBLabel5.HeightPercent := 100.000000000000000000;
    WebDBLabel5.ParentFont := False;
    WebDBLabel5.Transparent := False;
    WebDBLabel5.WidthPercent := 100.000000000000000000;
    WebDBLabel5.DataField := 'TyreCost';
    WebDBLabel5.DataSource := dsDashBoardSums;
    WebLabel8.SetParentComponent(wpTyres);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 0;
    WebLabel8.Top := 0;
    WebLabel8.Width := 150;
    WebLabel8.Height := 23;
    WebLabel8.Align := alTop;
    WebLabel8.Alignment := taCenter;
    WebLabel8.Caption := 'Tyre';
    WebLabel8.Color := clAqua;
    WebLabel8.Font.Charset := DEFAULT_CHARSET;
    WebLabel8.Font.Color := clWindowText;
    WebLabel8.Font.Height := -17;
    WebLabel8.Font.Name := 'Segoe UI';
    WebLabel8.Font.Style := [fsBold];
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.ParentFont := False;
    WebLabel8.Transparent := False;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebDBLabel12.SetParentComponent(wpTyres);
    WebDBLabel12.Name := 'WebDBLabel12';
    WebDBLabel12.Left := 0;
    WebDBLabel12.Top := 46;
    WebDBLabel12.Width := 150;
    WebDBLabel12.Height := 26;
    WebDBLabel12.Align := alClient;
    WebDBLabel12.Alignment := taCenter;
    WebDBLabel12.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel12.Font.Color := clWindowText;
    WebDBLabel12.Font.Height := -16;
    WebDBLabel12.Font.Name := 'Segoe UI';
    WebDBLabel12.Font.Style := [fsBold];
    WebDBLabel12.HeightPercent := 100.000000000000000000;
    WebDBLabel12.ParentFont := False;
    WebDBLabel12.WidthPercent := 100.000000000000000000;
    WebDBLabel12.DataField := 'TyreCPK';
    WebDBLabel12.DataSource := dsDashBoardSums;
    wpCost.SetParentComponent(wpDashSums);
    wpCost.Name := 'wpCost';
    wpCost.Left := 507;
    wpCost.Top := 0;
    wpCost.Width := 150;
    wpCost.Height := 72;
    wpCost.Align := alLeft;
    wpCost.ChildOrder := 7;
    wpCost.Color := clFuchsia;
    wpCost.TabOrder := 3;
    WebDBLabel3.SetParentComponent(wpCost);
    WebDBLabel3.Name := 'WebDBLabel3';
    WebDBLabel3.Left := 0;
    WebDBLabel3.Top := 23;
    WebDBLabel3.Width := 150;
    WebDBLabel3.Height := 23;
    WebDBLabel3.Align := alTop;
    WebDBLabel3.Alignment := taCenter;
    WebDBLabel3.Color := clFuchsia;
    WebDBLabel3.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel3.Font.Color := clWindowText;
    WebDBLabel3.Font.Height := -17;
    WebDBLabel3.Font.Name := 'Segoe UI';
    WebDBLabel3.Font.Style := [fsBold];
    WebDBLabel3.HeightPercent := 100.000000000000000000;
    WebDBLabel3.ParentFont := False;
    WebDBLabel3.WidthPercent := 100.000000000000000000;
    WebDBLabel3.DataField := 'WashCost';
    WebDBLabel3.DataSource := dsDashBoardSums;
    WebLabel9.SetParentComponent(wpCost);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 0;
    WebLabel9.Top := 0;
    WebLabel9.Width := 150;
    WebLabel9.Height := 23;
    WebLabel9.Align := alTop;
    WebLabel9.Alignment := taCenter;
    WebLabel9.Caption := 'Wash';
    WebLabel9.Font.Charset := DEFAULT_CHARSET;
    WebLabel9.Font.Color := clWindowText;
    WebLabel9.Font.Height := -17;
    WebLabel9.Font.Name := 'Segoe UI';
    WebLabel9.Font.Style := [fsBold];
    WebLabel9.HeightPercent := 100.000000000000000000;
    WebLabel9.ParentFont := False;
    WebLabel9.WidthPercent := 100.000000000000000000;
    WebDBLabel9.SetParentComponent(wpCost);
    WebDBLabel9.Name := 'WebDBLabel9';
    WebDBLabel9.Left := 0;
    WebDBLabel9.Top := 46;
    WebDBLabel9.Width := 150;
    WebDBLabel9.Height := 26;
    WebDBLabel9.Align := alClient;
    WebDBLabel9.Alignment := taCenter;
    WebDBLabel9.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel9.Font.Color := clWindowText;
    WebDBLabel9.Font.Height := -16;
    WebDBLabel9.Font.Name := 'Segoe UI';
    WebDBLabel9.Font.Style := [fsBold];
    WebDBLabel9.HeightPercent := 100.000000000000000000;
    WebDBLabel9.ParentFont := False;
    WebDBLabel9.WidthPercent := 100.000000000000000000;
    WebDBLabel9.DataField := 'WashCPK';
    WebDBLabel9.DataSource := dsDashBoardSums;
    wpInsurance.SetParentComponent(wpDashSums);
    wpInsurance.Name := 'wpInsurance';
    wpInsurance.Left := 657;
    wpInsurance.Top := 0;
    wpInsurance.Width := 150;
    wpInsurance.Height := 72;
    wpInsurance.Align := alLeft;
    wpInsurance.ChildOrder := 8;
    wpInsurance.Color := clLime;
    wpInsurance.TabOrder := 4;
    WebDBLabel4.SetParentComponent(wpInsurance);
    WebDBLabel4.Name := 'WebDBLabel4';
    WebDBLabel4.Left := 0;
    WebDBLabel4.Top := 23;
    WebDBLabel4.Width := 150;
    WebDBLabel4.Height := 24;
    WebDBLabel4.Align := alTop;
    WebDBLabel4.Alignment := taCenter;
    WebDBLabel4.AutoSize := False;
    WebDBLabel4.Color := clLime;
    WebDBLabel4.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel4.Font.Color := clWindowText;
    WebDBLabel4.Font.Height := -17;
    WebDBLabel4.Font.Name := 'Segoe UI';
    WebDBLabel4.Font.Style := [fsBold];
    WebDBLabel4.HeightPercent := 100.000000000000000000;
    WebDBLabel4.ParentFont := False;
    WebDBLabel4.WidthPercent := 100.000000000000000000;
    WebDBLabel4.DataField := 'InsuranceCost';
    WebDBLabel4.DataSource := dsDashBoardSums;
    WebLabel10.SetParentComponent(wpInsurance);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 0;
    WebLabel10.Top := 0;
    WebLabel10.Width := 150;
    WebLabel10.Height := 23;
    WebLabel10.Align := alTop;
    WebLabel10.Alignment := taCenter;
    WebLabel10.Caption := 'Insurance';
    WebLabel10.Font.Charset := DEFAULT_CHARSET;
    WebLabel10.Font.Color := clWindowText;
    WebLabel10.Font.Height := -17;
    WebLabel10.Font.Name := 'Segoe UI';
    WebLabel10.Font.Style := [fsBold];
    WebLabel10.HeightPercent := 100.000000000000000000;
    WebLabel10.ParentFont := False;
    WebLabel10.WidthPercent := 100.000000000000000000;
    WebDBLabel13.SetParentComponent(wpInsurance);
    WebDBLabel13.Name := 'WebDBLabel13';
    WebDBLabel13.Left := 0;
    WebDBLabel13.Top := 47;
    WebDBLabel13.Width := 150;
    WebDBLabel13.Height := 25;
    WebDBLabel13.Align := alClient;
    WebDBLabel13.Alignment := taCenter;
    WebDBLabel13.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel13.Font.Color := clWindowText;
    WebDBLabel13.Font.Height := -16;
    WebDBLabel13.Font.Name := 'Segoe UI';
    WebDBLabel13.Font.Style := [fsBold];
    WebDBLabel13.HeightPercent := 100.000000000000000000;
    WebDBLabel13.ParentFont := False;
    WebDBLabel13.WidthPercent := 100.000000000000000000;
    WebDBLabel13.DataField := 'InsuranceCPK';
    WebDBLabel13.DataSource := dsDashBoardSums;
    wpOperational.SetParentComponent(wpDashSums);
    wpOperational.Name := 'wpOperational';
    wpOperational.Left := 807;
    wpOperational.Top := 0;
    wpOperational.Width := 150;
    wpOperational.Height := 72;
    wpOperational.Align := alLeft;
    wpOperational.ChildOrder := 9;
    wpOperational.Color := clTeal;
    wpOperational.TabOrder := 5;
    WebDBLabel6.SetParentComponent(wpOperational);
    WebDBLabel6.Name := 'WebDBLabel6';
    WebDBLabel6.Left := 0;
    WebDBLabel6.Top := 23;
    WebDBLabel6.Width := 150;
    WebDBLabel6.Height := 24;
    WebDBLabel6.Align := alTop;
    WebDBLabel6.Alignment := taCenter;
    WebDBLabel6.AutoSize := False;
    WebDBLabel6.Color := clTeal;
    WebDBLabel6.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel6.Font.Color := clWindowText;
    WebDBLabel6.Font.Height := -17;
    WebDBLabel6.Font.Name := 'Segoe UI';
    WebDBLabel6.Font.Style := [fsBold];
    WebDBLabel6.HeightPercent := 100.000000000000000000;
    WebDBLabel6.ParentFont := False;
    WebDBLabel6.WidthPercent := 100.000000000000000000;
    WebDBLabel6.DataField := 'OtherCost';
    WebDBLabel6.DataSource := dsDashBoardSums;
    WebLabel11.SetParentComponent(wpOperational);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 0;
    WebLabel11.Top := 0;
    WebLabel11.Width := 150;
    WebLabel11.Height := 23;
    WebLabel11.Align := alTop;
    WebLabel11.Alignment := taCenter;
    WebLabel11.Caption := 'Operational';
    WebLabel11.Font.Charset := DEFAULT_CHARSET;
    WebLabel11.Font.Color := clWindowText;
    WebLabel11.Font.Height := -17;
    WebLabel11.Font.Name := 'Segoe UI';
    WebLabel11.Font.Style := [fsBold];
    WebLabel11.HeightPercent := 100.000000000000000000;
    WebLabel11.ParentFont := False;
    WebLabel11.WidthPercent := 100.000000000000000000;
    WebDBLabel14.SetParentComponent(wpOperational);
    WebDBLabel14.Name := 'WebDBLabel14';
    WebDBLabel14.Left := 0;
    WebDBLabel14.Top := 47;
    WebDBLabel14.Width := 150;
    WebDBLabel14.Height := 25;
    WebDBLabel14.Align := alClient;
    WebDBLabel14.Alignment := taCenter;
    WebDBLabel14.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel14.Font.Color := clWindowText;
    WebDBLabel14.Font.Height := -16;
    WebDBLabel14.Font.Name := 'Segoe UI';
    WebDBLabel14.Font.Style := [fsBold];
    WebDBLabel14.HeightPercent := 100.000000000000000000;
    WebDBLabel14.ParentFont := False;
    WebDBLabel14.WidthPercent := 100.000000000000000000;
    WebDBLabel14.DataField := 'OtherCPK';
    WebDBLabel14.DataSource := dsDashBoardSums;
    wbSearch.SetParentComponent(wpDashSums);
    wbSearch.Name := 'wbSearch';
    wbSearch.Left := 1407;
    wbSearch.Top := 0;
    wbSearch.Width := 96;
    wbSearch.Height := 72;
    wbSearch.Align := alLeft;
    wbSearch.Caption := 'Search';
    wbSearch.ChildOrder := 5;
    wbSearch.HeightPercent := 100.000000000000000000;
    wbSearch.WidthPercent := 100.000000000000000000;
    SetEvent(wbSearch, Self, 'OnClick', 'wbSearchClick');
    wpCapex.SetParentComponent(wpDashSums);
    wpCapex.Name := 'wpCapex';
    wpCapex.Left := 957;
    wpCapex.Top := 0;
    wpCapex.Width := 150;
    wpCapex.Height := 72;
    wpCapex.Align := alLeft;
    wpCapex.ChildOrder := 7;
    wpCapex.Color := clGoldenrod;
    wpCapex.TabOrder := 7;
    WebLabel13.SetParentComponent(wpCapex);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 0;
    WebLabel13.Top := 0;
    WebLabel13.Width := 150;
    WebLabel13.Height := 23;
    WebLabel13.Align := alTop;
    WebLabel13.Alignment := taCenter;
    WebLabel13.Caption := 'Capex';
    WebLabel13.Font.Charset := DEFAULT_CHARSET;
    WebLabel13.Font.Color := clWindowText;
    WebLabel13.Font.Height := -17;
    WebLabel13.Font.Name := 'Segoe UI';
    WebLabel13.Font.Style := [fsBold];
    WebLabel13.HeightPercent := 100.000000000000000000;
    WebLabel13.ParentFont := False;
    WebLabel13.WidthPercent := 100.000000000000000000;
    WebDBLabel7.SetParentComponent(wpCapex);
    WebDBLabel7.Name := 'WebDBLabel7';
    WebDBLabel7.Left := 0;
    WebDBLabel7.Top := 23;
    WebDBLabel7.Width := 150;
    WebDBLabel7.Height := 24;
    WebDBLabel7.Align := alTop;
    WebDBLabel7.Alignment := taCenter;
    WebDBLabel7.AutoSize := False;
    WebDBLabel7.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel7.Font.Color := clWindowText;
    WebDBLabel7.Font.Height := -17;
    WebDBLabel7.Font.Name := 'Segoe UI';
    WebDBLabel7.Font.Style := [fsBold];
    WebDBLabel7.HeightPercent := 100.000000000000000000;
    WebDBLabel7.ParentFont := False;
    WebDBLabel7.WidthPercent := 100.000000000000000000;
    WebDBLabel7.DataField := 'CapexCost';
    WebDBLabel7.DataSource := dsDashBoardSums;
    WebDBLabel15.SetParentComponent(wpCapex);
    WebDBLabel15.Name := 'WebDBLabel15';
    WebDBLabel15.Left := 0;
    WebDBLabel15.Top := 47;
    WebDBLabel15.Width := 150;
    WebDBLabel15.Height := 25;
    WebDBLabel15.Align := alClient;
    WebDBLabel15.Alignment := taCenter;
    WebDBLabel15.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel15.Font.Color := clWindowText;
    WebDBLabel15.Font.Height := -16;
    WebDBLabel15.Font.Name := 'Segoe UI';
    WebDBLabel15.Font.Style := [fsBold];
    WebDBLabel15.HeightPercent := 100.000000000000000000;
    WebDBLabel15.ParentFont := False;
    WebDBLabel15.WidthPercent := 100.000000000000000000;
    WebDBLabel15.DataField := 'CapexCPK';
    WebDBLabel15.DataSource := dsDashBoardSums;
    wpUnAll.SetParentComponent(wpDashSums);
    wpUnAll.Name := 'wpUnAll';
    wpUnAll.Left := 1107;
    wpUnAll.Top := 0;
    wpUnAll.Width := 150;
    wpUnAll.Height := 72;
    wpUnAll.Align := alLeft;
    wpUnAll.ChildOrder := 8;
    wpUnAll.Color := clChocolate;
    wpUnAll.TabOrder := 8;
    WebLabel14.SetParentComponent(wpUnAll);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 0;
    WebLabel14.Top := 0;
    WebLabel14.Width := 150;
    WebLabel14.Height := 23;
    WebLabel14.Align := alTop;
    WebLabel14.Alignment := taCenter;
    WebLabel14.Caption := 'Unallocated';
    WebLabel14.Font.Charset := DEFAULT_CHARSET;
    WebLabel14.Font.Color := clWindowText;
    WebLabel14.Font.Height := -17;
    WebLabel14.Font.Name := 'Segoe UI';
    WebLabel14.Font.Style := [fsBold];
    WebLabel14.HeightPercent := 100.000000000000000000;
    WebLabel14.ParentFont := False;
    WebLabel14.WidthPercent := 100.000000000000000000;
    WebDBLabel8.SetParentComponent(wpUnAll);
    WebDBLabel8.Name := 'WebDBLabel8';
    WebDBLabel8.Left := 0;
    WebDBLabel8.Top := 23;
    WebDBLabel8.Width := 150;
    WebDBLabel8.Height := 24;
    WebDBLabel8.Align := alTop;
    WebDBLabel8.Alignment := taCenter;
    WebDBLabel8.AutoSize := False;
    WebDBLabel8.Color := clChartreuse;
    WebDBLabel8.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel8.Font.Color := clWindowText;
    WebDBLabel8.Font.Height := -17;
    WebDBLabel8.Font.Name := 'Segoe UI';
    WebDBLabel8.Font.Style := [fsBold];
    WebDBLabel8.HeightPercent := 100.000000000000000000;
    WebDBLabel8.ParentFont := False;
    WebDBLabel8.WidthPercent := 100.000000000000000000;
    WebDBLabel8.DataField := 'UnallCost';
    WebDBLabel8.DataSource := dsDashBoardSums;
    WebDBLabel16.SetParentComponent(wpUnAll);
    WebDBLabel16.Name := 'WebDBLabel16';
    WebDBLabel16.Left := 0;
    WebDBLabel16.Top := 47;
    WebDBLabel16.Width := 150;
    WebDBLabel16.Height := 21;
    WebDBLabel16.Align := alTop;
    WebDBLabel16.Alignment := taCenter;
    WebDBLabel16.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel16.Font.Color := clWindowText;
    WebDBLabel16.Font.Height := -16;
    WebDBLabel16.Font.Name := 'Segoe UI';
    WebDBLabel16.Font.Style := [fsBold];
    WebDBLabel16.HeightPercent := 100.000000000000000000;
    WebDBLabel16.ParentFont := False;
    WebDBLabel16.WidthPercent := 100.000000000000000000;
    WebDBLabel16.DataField := 'UnallCPK';
    WebDBLabel16.DataSource := dsDashBoardSums;
    WebPanel1.SetParentComponent(wpDashSums);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 57;
    WebPanel1.Height := 72;
    WebPanel1.Align := alLeft;
    WebPanel1.ChildOrder := 9;
    WebPanel1.TabOrder := 9;
    WebLabel12.SetParentComponent(WebPanel1);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 0;
    WebLabel12.Top := 0;
    WebLabel12.Width := 57;
    WebLabel12.Height := 15;
    WebLabel12.Align := alTop;
    WebLabel12.HeightPercent := 100.000000000000000000;
    WebLabel12.WidthPercent := 100.000000000000000000;
    WebLabel15.SetParentComponent(WebPanel1);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 0;
    WebLabel15.Top := 15;
    WebLabel15.Width := 57;
    WebLabel15.Height := 21;
    WebLabel15.Align := alTop;
    WebLabel15.Alignment := taRightJustify;
    WebLabel15.Caption := 'Cost : ';
    WebLabel15.Font.Charset := DEFAULT_CHARSET;
    WebLabel15.Font.Color := clWindowText;
    WebLabel15.Font.Height := -16;
    WebLabel15.Font.Name := 'Segoe UI';
    WebLabel15.Font.Style := [fsBold];
    WebLabel15.HeightPercent := 100.000000000000000000;
    WebLabel15.ParentFont := False;
    WebLabel15.WidthPercent := 100.000000000000000000;
    WebLabel16.SetParentComponent(WebPanel1);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 0;
    WebLabel16.Top := 36;
    WebLabel16.Width := 57;
    WebLabel16.Height := 21;
    WebLabel16.Align := alTop;
    WebLabel16.Alignment := taRightJustify;
    WebLabel16.Caption := 'CPK : ';
    WebLabel16.Font.Charset := DEFAULT_CHARSET;
    WebLabel16.Font.Color := clWindowText;
    WebLabel16.Font.Height := -16;
    WebLabel16.Font.Name := 'Segoe UI';
    WebLabel16.Font.Style := [fsBold];
    WebLabel16.HeightPercent := 100.000000000000000000;
    WebLabel16.ParentFont := False;
    WebLabel16.WidthPercent := 100.000000000000000000;
    wbExcel.SetParentComponent(wpDashSums);
    wbExcel.Name := 'wbExcel';
    wbExcel.Left := 1503;
    wbExcel.Top := 0;
    wbExcel.Width := 96;
    wbExcel.Height := 72;
    wbExcel.Align := alLeft;
    wbExcel.Caption := 'Excel Export';
    wbExcel.ChildOrder := 10;
    wbExcel.HeightPercent := 100.000000000000000000;
    wbExcel.WidthPercent := 100.000000000000000000;
    SetEvent(wbExcel, Self, 'OnClick', 'wbExcelClick');
    wpNoLink.SetParentComponent(wpDashSums);
    wpNoLink.Name := 'wpNoLink';
    wpNoLink.Left := 1257;
    wpNoLink.Top := 0;
    wpNoLink.Width := 150;
    wpNoLink.Height := 72;
    wpNoLink.Align := alLeft;
    wpNoLink.ChildOrder := 11;
    wpNoLink.TabOrder := 11;
    WebLabel17.SetParentComponent(wpNoLink);
    WebLabel17.Name := 'WebLabel17';
    WebLabel17.Left := 0;
    WebLabel17.Top := 0;
    WebLabel17.Width := 150;
    WebLabel17.Height := 23;
    WebLabel17.Align := alTop;
    WebLabel17.Alignment := taCenter;
    WebLabel17.Caption := 'Not linked';
    WebLabel17.Color := clCornflowerblue;
    WebLabel17.Font.Charset := DEFAULT_CHARSET;
    WebLabel17.Font.Color := clWindowText;
    WebLabel17.Font.Height := -17;
    WebLabel17.Font.Name := 'Segoe UI';
    WebLabel17.Font.Style := [fsBold];
    WebLabel17.HeightPercent := 100.000000000000000000;
    WebLabel17.ParentFont := False;
    WebLabel17.Transparent := False;
    WebLabel17.WidthPercent := 100.000000000000000000;
    WebDBLabel17.SetParentComponent(wpNoLink);
    WebDBLabel17.Name := 'WebDBLabel17';
    WebDBLabel17.Left := 0;
    WebDBLabel17.Top := 23;
    WebDBLabel17.Width := 150;
    WebDBLabel17.Height := 23;
    WebDBLabel17.Align := alTop;
    WebDBLabel17.Alignment := taCenter;
    WebDBLabel17.Color := clCornflowerblue;
    WebDBLabel17.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel17.Font.Color := clWindowText;
    WebDBLabel17.Font.Height := -17;
    WebDBLabel17.Font.Name := 'Segoe UI';
    WebDBLabel17.Font.Style := [fsBold];
    WebDBLabel17.HeightPercent := 100.000000000000000000;
    WebDBLabel17.ParentFont := False;
    WebDBLabel17.Transparent := False;
    WebDBLabel17.WidthPercent := 100.000000000000000000;
    WebDBLabel17.DataField := 'NotLinkedCost';
    WebDBLabel17.DataSource := dsDashBoardSums;
    WebDBLabel18.SetParentComponent(wpNoLink);
    WebDBLabel18.Name := 'WebDBLabel18';
    WebDBLabel18.Left := 0;
    WebDBLabel18.Top := 46;
    WebDBLabel18.Width := 150;
    WebDBLabel18.Height := 26;
    WebDBLabel18.Align := alClient;
    WebDBLabel18.Alignment := taCenter;
    WebDBLabel18.Color := clCornflowerblue;
    WebDBLabel18.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel18.Font.Color := clWindowText;
    WebDBLabel18.Font.Height := -16;
    WebDBLabel18.Font.Name := 'Segoe UI';
    WebDBLabel18.Font.Style := [fsBold];
    WebDBLabel18.HeightPercent := 100.000000000000000000;
    WebDBLabel18.ParentFont := False;
    WebDBLabel18.Transparent := False;
    WebDBLabel18.WidthPercent := 100.000000000000000000;
    WebDBLabel18.DataField := 'NotLinkedCPK';
    WebDBLabel18.DataSource := dsDashBoardSums;
    pDashData.SetParentComponent(pMain);
    pDashData.Name := 'pDashData';
    pDashData.Left := 0;
    pDashData.Top := 265;
    pDashData.Width := 1714;
    pDashData.Height := 232;
    pDashData.WidthStyle := ssPercent;
    pDashData.WidthPercent := 99.000000000000000000;
    pDashData.Align := alClient;
    pDashData.Caption := 'pDashData';
    pDashData.ChildOrder := 3;
    pDashData.TabOrder := 3;
    dgDashData.SetParentComponent(pDashData);
    dgDashData.Name := 'dgDashData';
    dgDashData.Left := 0;
    dgDashData.Top := 0;
    dgDashData.Width := 1714;
    dgDashData.Height := 232;
    dgDashData.Align := alClient;
    dgDashData.ParentDoubleBuffered := False;
    dgDashData.DoubleBuffered := True;
    dgDashData.TabOrder := 0;
    dgDashData.ShowAcceleratorChar := False;
    dgDashData.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgDashData.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgDashData.Header.VisualGrouping.Layout.Font.Height := -12;
    dgDashData.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgDashData.Header.VisualGrouping.Layout.Font.Style := [];
    dgDashData.Adapter := dgdaDashData;
    dgDashData.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgDashData.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgDashData.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgDashData.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgDashData.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgDashData.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgDashData.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgDashData.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgDashData.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgDashData.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgDashData.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgDashData.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgDashData.CellAppearance.BandLayout.Font.Height := -12;
    dgDashData.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgDashData.CellAppearance.BandLayout.Font.Style := [];
    dgDashData.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgDashData.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgDashData.CellAppearance.FixedLayout.Font.Height := -12;
    dgDashData.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgDashData.CellAppearance.FixedLayout.Font.Style := [];
    dgDashData.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgDashData.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgDashData.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgDashData.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgDashData.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgDashData.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgDashData.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgDashData.CellAppearance.FocusedLayout.Font.Height := -12;
    dgDashData.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgDashData.CellAppearance.FocusedLayout.Font.Style := [];
    dgDashData.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgDashData.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgDashData.CellAppearance.GroupLayout.Font.Height := -12;
    dgDashData.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgDashData.CellAppearance.GroupLayout.Font.Style := [];
    dgDashData.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgDashData.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgDashData.CellAppearance.NormalLayout.Font.Height := -12;
    dgDashData.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgDashData.CellAppearance.NormalLayout.Font.Style := [];
    dgDashData.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgDashData.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgDashData.CellAppearance.SelectedLayout.Font.Height := -12;
    dgDashData.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgDashData.CellAppearance.SelectedLayout.Font.Style := [];
    dgDashData.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgDashData.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgDashData.CellAppearance.SummaryLayout.Font.Height := -12;
    dgDashData.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgDashData.CellAppearance.SummaryLayout.Font.Style := [];
    dgDashData.ColumnCount := 14;
    dgDashData.Columns.Clear;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Vehichle Type ';
      Width := 122.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Fleet No';
      Width := 122.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Jobcard Date';
      Width := 122.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Job No';
      Width := 122.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Order No';
      Width := 122.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Ref No';
      Width := 122.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Cost Category';
      Width := 122.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'GL Code';
      Width := 122.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Cost Description';
      Width := 122.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Stock Description';
      Width := 122.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Total Excl';
      Width := 122.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Job Type';
      Width := 122.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Supplier';
      Width := 122.000000000000000000;
    end;
    with dgDashData.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Comment';
      Width := 128.000000000000000000;
    end;
    dgDashData.Designer := False;
    dgDashData.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgDashData.FilterAppearance.Font.Color := clWindowText;
    dgDashData.FilterAppearance.Font.Height := -12;
    dgDashData.FilterAppearance.Font.Name := 'Segoe UI';
    dgDashData.FilterAppearance.Font.Style := [];
    dgDashData.Icons.ExpandIcon.LoadFromFile('dashboard.maintenance.pDashData.dgDashData.Icons.ExpandIcon.svg');
    dgDashData.Icons.CollapseIcon.LoadFromFile('dashboard.maintenance.pDashData.dgDashData.Icons.CollapseIcon.svg');
    dgDashData.Icons.FilterIcon.LoadFromFile('dashboard.maintenance.pDashData.dgDashData.Icons.FilterIcon.svg');
    dgDashData.Icons.FilterActiveIcon.LoadFromFile('dashboard.maintenance.pDashData.dgDashData.Icons.FilterActiveIcon.svg');
    dgDashData.Icons.FilterClearIcon.LoadFromFile('dashboard.maintenance.pDashData.dgDashData.Icons.FilterClearIcon.svg');
    dgDashData.Icons.FilterTypeIcon.LoadFromFile('dashboard.maintenance.pDashData.dgDashData.Icons.FilterTypeIcon.svg');
    dgDashData.Icons.SortAscendingIcon.LoadFromFile('dashboard.maintenance.pDashData.dgDashData.Icons.SortAscendingIcon.svg');
    dgDashData.Icons.SortDescendingIcon.LoadFromFile('dashboard.maintenance.pDashData.dgDashData.Icons.SortDescendingIcon.svg');
    dgDashData.Icons.CloseIcon.LoadFromFile('dashboard.maintenance.pDashData.dgDashData.Icons.CloseIcon.svg');
    dgDashData.Options.Sorting.Enabled := True;
    dgDashData.Options.Column.Stretching.Enabled := True;
    dgDashData.Options.Editing.Enabled := False;
    dgDashData.RowCount := 1;
    dgdaDashData.SetParentComponent(dgDashData);
    dgdaDashData.Name := 'dgdaDashData';
    dgdaDashData.Left := 331;
    dgdaDashData.Top := 104;
    dgdaDashData.Width := 26;
    dgdaDashData.Height := 26;
    dgdaDashData.Visible := True;
    dgdaDashData.AutoCreateColumns := False;
    dgdaDashData.AutoRemoveColumns := False;
    dgdaDashData.Columns.Clear;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'Vehtype';
      Header := 'Vehichle Type ';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'TFleetNo';
      Header := 'Fleet No';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'JobDate';
      Header := 'Jobcard Date';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'JobcardNo';
      Header := 'Job No';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'OrderNo';
      Header := 'Order No';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'ReferenceNo';
      Header := 'Ref No';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'Category';
      Header := 'Cost Category';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'GlCode';
      Header := 'GL Code';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'CostDescription';
      Header := 'Cost Description';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'StockDescription';
      Header := 'Stock Description';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'TotalExcl';
      Header := 'Total Excl';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'JobType';
      Header := 'Job Type';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'Supplier';
      Header := 'Supplier';
      AutoCreated := False;
    end;
    with dgdaDashData.Columns.Add do
    begin
      FieldName := 'Reason';
      Header := 'Comment';
      AutoCreated := False;
    end;
    dgdaDashData.DataSource := dsDashData;
    dgdaDashData.LoadMode := almAllRecords;
    WebWaitMessage1.SetParentComponent(dgDashData);
    WebWaitMessage1.Name := 'WebWaitMessage1';
    WebWaitMessage1.Left := 528;
    WebWaitMessage1.Top := 112;
    WebWaitMessage1.Width := 24;
    WebWaitMessage1.Height := 24;
    WebWaitMessage1.Opacity := 0.200000000000000000;
    WebWaitMessage1.Picture.LoadFromFile('dashboard.maintenance.dgDashData.WebWaitMessage1.Picture.gif');
    BitmapContainer1.SetParentComponent(dgDashData);
    BitmapContainer1.Name := 'BitmapContainer1';
    BitmapContainer1.Left := 407;
    BitmapContainer1.Top := 56;
    BitmapContainer1.Width := 26;
    BitmapContainer1.Height := 26;
    BitmapContainer1.Visible := True;
    BitmapContainer1.Items.Clear;
    with BitmapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('dashboard.maintenance.BitmapContainer1.Items.Bitmap.png');
      Name := 'green-switch.png';
      Tag := 0;
    end;
    with BitmapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('dashboard.maintenance.BitmapContainer1.Items.Bitmap_1.png');
      Name := 'red-switch.png';
      Tag := 0;
    end;
    with BitmapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('dashboard.maintenance.BitmapContainer1.Items.Bitmap.svg');
      Name := 'green-switch.svg';
      Tag := 0;
    end;
    with BitmapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('dashboard.maintenance.BitmapContainer1.Items.Bitmap_1.svg');
      Name := 'red-switch.svg';
      Tag := 0;
    end;
    wcYears.SetParentComponent(Self);
    wcYears.Name := 'wcYears';
    wcYears.Connection := dmData.dbConnect;
    wcYears.Left := 120;
    wcYears.Top := 112;
    wdsYears.SetParentComponent(Self);
    wdsYears.Name := 'wdsYears';
    wdsYears.AfterPost := wdsYearsAfterPost;
    wdsYears.Connection := dmData.dbConnect;
    wdsYears.Left := 72;
    wdsYears.Top := 152;
    wdsYearsSelected.SetParentComponent(wdsYears);
    wdsYearsSelected.Name := 'wdsYearsSelected';
    wdsYearsSelected.FieldName := 'Selected';
    wdsYearsYear.SetParentComponent(wdsYears);
    wdsYearsYear.Name := 'wdsYearsYear';
    wdsYearsYear.FieldName := 'Year';
    dsYears.SetParentComponent(Self);
    dsYears.Name := 'dsYears';
    dsYears.AutoEdit := False;
    dsYears.DataSet := wdsYears;
    dsYears.Left := 24;
    dsYears.Top := 152;
    wcMonths.SetParentComponent(Self);
    wcMonths.Name := 'wcMonths';
    wcMonths.Connection := dmData.dbConnect;
    wcMonths.Left := 177;
    wcMonths.Top := 88;
    wdsMonths.SetParentComponent(Self);
    wdsMonths.Name := 'wdsMonths';
    wdsMonths.AfterPost := wdsMonthsAfterPost;
    wdsMonths.Connection := dmData.dbConnect;
    wdsMonths.Left := 169;
    wdsMonths.Top := 176;
    wdsMonthsMonth.SetParentComponent(wdsMonths);
    wdsMonthsMonth.Name := 'wdsMonthsMonth';
    wdsMonthsMonth.FieldName := 'Month';
    wdsMonthsMonthName.SetParentComponent(wdsMonths);
    wdsMonthsMonthName.Name := 'wdsMonthsMonthName';
    wdsMonthsMonthName.FieldName := 'MonthName';
    wdsMonthsSelected.SetParentComponent(wdsMonths);
    wdsMonthsSelected.Name := 'wdsMonthsSelected';
    wdsMonthsSelected.FieldName := 'Selected';
    dsMonths.SetParentComponent(Self);
    dsMonths.Name := 'dsMonths';
    dsMonths.AutoEdit := False;
    dsMonths.DataSet := wdsMonths;
    dsMonths.Left := 241;
    dsMonths.Top := 144;
    wcReg.SetParentComponent(Self);
    wcReg.Name := 'wcReg';
    wcReg.Connection := dmData.dbConnect;
    wcReg.Left := 362;
    wcReg.Top := 88;
    wdsReg.SetParentComponent(Self);
    wdsReg.Name := 'wdsReg';
    wdsReg.Connection := dmData.dbConnect;
    wdsReg.Left := 394;
    wdsReg.Top := 144;
    wdsRegReg.SetParentComponent(wdsReg);
    wdsRegReg.Name := 'wdsRegReg';
    wdsRegReg.FieldName := 'Reg';
    wdsRegFleetNo.SetParentComponent(wdsReg);
    wdsRegFleetNo.Name := 'wdsRegFleetNo';
    wdsRegFleetNo.FieldName := 'FleetNo';
    wdsRegFleetType.SetParentComponent(wdsReg);
    wdsRegFleetType.Name := 'wdsRegFleetType';
    wdsRegFleetType.FieldName := 'FleetType';
    wdsRegSelected.SetParentComponent(wdsReg);
    wdsRegSelected.Name := 'wdsRegSelected';
    wdsRegSelected.FieldName := 'Selected';
    wdsRegPriKey.SetParentComponent(wdsReg);
    wdsRegPriKey.Name := 'wdsRegPriKey';
    wdsRegPriKey.FieldName := 'PriKey';
    dsReg.SetParentComponent(Self);
    dsReg.Name := 'dsReg';
    dsReg.AutoEdit := False;
    dsReg.DataSet := wdsReg;
    dsReg.Left := 450;
    dsReg.Top := 144;
    WebTimer1.SetParentComponent(Self);
    WebTimer1.Name := 'WebTimer1';
    WebTimer1.Enabled := False;
    SetEvent(WebTimer1, Self, 'OnTimer', 'WebTimer1Timer');
    WebTimer1.Left := 584;
    WebTimer1.Top := 313;
    wdsTempReg.SetParentComponent(Self);
    wdsTempReg.Name := 'wdsTempReg';
    wdsTempReg.Connection := dmData.dbConnect;
    wdsTempReg.Left := 514;
    wdsTempReg.Top := 104;
    StringField1.SetParentComponent(wdsTempReg);
    StringField1.Name := 'StringField1';
    StringField1.FieldName := 'Reg';
    StringField2.SetParentComponent(wdsTempReg);
    StringField2.Name := 'StringField2';
    StringField2.FieldName := 'FleetNo';
    StringField3.SetParentComponent(wdsTempReg);
    StringField3.Name := 'StringField3';
    StringField3.FieldName := 'FleetType';
    BooleanField1.SetParentComponent(wdsTempReg);
    BooleanField1.Name := 'BooleanField1';
    BooleanField1.FieldName := 'Selected';
    IntegerField1.SetParentComponent(wdsTempReg);
    IntegerField1.Name := 'IntegerField1';
    IntegerField1.FieldName := 'PriKey';
    dsSysTypes.SetParentComponent(Self);
    dsSysTypes.Name := 'dsSysTypes';
    dsSysTypes.AutoEdit := False;
    dsSysTypes.DataSet := wdsSysTypes;
    dsSysTypes.Left := 649;
    dsSysTypes.Top := 145;
    wcSysTypes.SetParentComponent(Self);
    wcSysTypes.Name := 'wcSysTypes';
    wcSysTypes.Connection := dmData.dbConnect;
    wcSysTypes.Left := 705;
    wcSysTypes.Top := 137;
    wdsSysTypes.SetParentComponent(Self);
    wdsSysTypes.Name := 'wdsSysTypes';
    wdsSysTypes.AfterPost := wdsSysTypesAfterPost;
    wdsSysTypes.Connection := dmData.dbConnect;
    wdsSysTypes.Left := 689;
    wdsSysTypes.Top := 81;
    wdsSysTypesSelected.SetParentComponent(wdsSysTypes);
    wdsSysTypesSelected.Name := 'wdsSysTypesSelected';
    wdsSysTypesSelected.FieldName := 'Selected';
    wdsSysTypesSysType.SetParentComponent(wdsSysTypes);
    wdsSysTypesSysType.Name := 'wdsSysTypesSysType';
    wdsSysTypesSysType.FieldName := 'SysType';
    wdsSysTypesDescription.SetParentComponent(wdsSysTypes);
    wdsSysTypesDescription.Name := 'wdsSysTypesDescription';
    wdsSysTypesDescription.FieldName := 'Description';
    wdsCostGroups.SetParentComponent(Self);
    wdsCostGroups.Name := 'wdsCostGroups';
    wdsCostGroups.AfterPost := wdsCostGroupsAfterPost;
    wdsCostGroups.Connection := dmData.dbConnect;
    wdsCostGroups.Left := 825;
    wdsCostGroups.Top := 96;
    wdsCostGroupsselected.SetParentComponent(wdsCostGroups);
    wdsCostGroupsselected.Name := 'wdsCostGroupsselected';
    wdsCostGroupsselected.FieldName := 'Selected';
    wdsCostGroupsCost.SetParentComponent(wdsCostGroups);
    wdsCostGroupsCost.Name := 'wdsCostGroupsCost';
    wdsCostGroupsCost.FieldName := 'Cost';
    wdsCostGroupsDescription.SetParentComponent(wdsCostGroups);
    wdsCostGroupsDescription.Name := 'wdsCostGroupsDescription';
    wdsCostGroupsDescription.FieldName := 'Description';
    dsCostGroups.SetParentComponent(Self);
    dsCostGroups.Name := 'dsCostGroups';
    dsCostGroups.DataSet := wdsCostGroups;
    dsCostGroups.Left := 937;
    dsCostGroups.Top := 144;
    wcCostGroups.SetParentComponent(Self);
    wcCostGroups.Name := 'wcCostGroups';
    wcCostGroups.Connection := dmData.dbConnect;
    wcCostGroups.Left := 873;
    wcCostGroups.Top := 144;
    wdsDashboardSums.SetParentComponent(Self);
    wdsDashboardSums.Name := 'wdsDashboardSums';
    wdsDashboardSums.AfterOpen := wdsDashboardSumsAfterOpen;
    wdsDashboardSums.Connection := dmData.dbConnect;
    wdsDashboardSums.Left := 920;
    wdsDashboardSums.Top := 241;
    wdsDashboardSumsMaintenanceCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsMaintenanceCost.Name := 'wdsDashboardSumsMaintenanceCost';
    wdsDashboardSumsMaintenanceCost.FieldName := 'MaintenanceCost';
    wdsDashboardSumsTyreCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsTyreCost.Name := 'wdsDashboardSumsTyreCost';
    wdsDashboardSumsTyreCost.FieldName := 'TyreCost';
    wdsDashboardSumsWashCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsWashCost.Name := 'wdsDashboardSumsWashCost';
    wdsDashboardSumsWashCost.FieldName := 'WashCost';
    wdsDashboardSumsInsuranceCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsInsuranceCost.Name := 'wdsDashboardSumsInsuranceCost';
    wdsDashboardSumsInsuranceCost.FieldName := 'InsuranceCost';
    wdsDashboardSumsOtherCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsOtherCost.Name := 'wdsDashboardSumsOtherCost';
    wdsDashboardSumsOtherCost.FieldName := 'OtherCost';
    wdsDashboardSumsTotalCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsTotalCost.Name := 'wdsDashboardSumsTotalCost';
    wdsDashboardSumsTotalCost.FieldName := 'TotalCost';
    wdsDashboardSumsCapexCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsCapexCost.Name := 'wdsDashboardSumsCapexCost';
    wdsDashboardSumsCapexCost.FieldName := 'CapexCost';
    wdsDashboardSumsUnallCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsUnallCost.Name := 'wdsDashboardSumsUnallCost';
    wdsDashboardSumsUnallCost.FieldName := 'UnallCost';
    wdsDashboardSumsTotalCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsTotalCPK.Name := 'wdsDashboardSumsTotalCPK';
    wdsDashboardSumsTotalCPK.FieldName := 'TotalCPK';
    wdsDashboardSumsMaintenanceCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsMaintenanceCPK.Name := 'wdsDashboardSumsMaintenanceCPK';
    wdsDashboardSumsMaintenanceCPK.FieldName := 'MaintenanceCPK';
    wdsDashboardSumsTyreCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsTyreCPK.Name := 'wdsDashboardSumsTyreCPK';
    wdsDashboardSumsTyreCPK.FieldName := 'TyreCPK';
    wdsDashboardSumsWashCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsWashCPK.Name := 'wdsDashboardSumsWashCPK';
    wdsDashboardSumsWashCPK.FieldName := 'WashCPK';
    wdsDashboardSumsInsuranceCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsInsuranceCPK.Name := 'wdsDashboardSumsInsuranceCPK';
    wdsDashboardSumsInsuranceCPK.FieldName := 'InsuranceCPK';
    wdsDashboardSumsOtherCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsOtherCPK.Name := 'wdsDashboardSumsOtherCPK';
    wdsDashboardSumsOtherCPK.FieldName := 'OtherCPK';
    wdsDashboardSumsCapexCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsCapexCPK.Name := 'wdsDashboardSumsCapexCPK';
    wdsDashboardSumsCapexCPK.FieldName := 'CapexCPK';
    wdsDashboardSumsUnallCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsUnallCPK.Name := 'wdsDashboardSumsUnallCPK';
    wdsDashboardSumsUnallCPK.FieldName := 'UnallCPK';
    wdsDashboardSumsNotLinkedCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsNotLinkedCost.Name := 'wdsDashboardSumsNotLinkedCost';
    wdsDashboardSumsNotLinkedCost.FieldName := 'NotLinkedCost';
    wdsDashboardSumsNotLinkedCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsNotLinkedCPK.Name := 'wdsDashboardSumsNotLinkedCPK';
    wdsDashboardSumsNotLinkedCPK.FieldName := 'NotLinkedCPK';
    wdsDashData.SetParentComponent(Self);
    wdsDashData.Name := 'wdsDashData';
    wdsDashData.AfterOpen := wdsDashDataAfterOpen;
    wdsDashData.Connection := dmData.dbConnect;
    wdsDashData.Left := 264;
    wdsDashData.Top := 424;
    wdsDashDataJobcardNo.SetParentComponent(wdsDashData);
    wdsDashDataJobcardNo.Name := 'wdsDashDataJobcardNo';
    wdsDashDataJobcardNo.FieldName := 'JobcardNo';
    wdsDashDataStockDescription.SetParentComponent(wdsDashData);
    wdsDashDataStockDescription.Name := 'wdsDashDataStockDescription';
    wdsDashDataStockDescription.FieldName := 'StockDescription';
    wdsDashDataTotalExcl.SetParentComponent(wdsDashData);
    wdsDashDataTotalExcl.Name := 'wdsDashDataTotalExcl';
    wdsDashDataTotalExcl.FieldName := 'TotalExcl';
    wdsDashDataGlCode.SetParentComponent(wdsDashData);
    wdsDashDataGlCode.Name := 'wdsDashDataGlCode';
    wdsDashDataGlCode.FieldName := 'GlCode';
    wdsDashDataReason.SetParentComponent(wdsDashData);
    wdsDashDataReason.Name := 'wdsDashDataReason';
    wdsDashDataReason.FieldName := 'Reason';
    wdsDashDataCategory.SetParentComponent(wdsDashData);
    wdsDashDataCategory.Name := 'wdsDashDataCategory';
    wdsDashDataCategory.FieldName := 'Category';
    wdsDashDataRepMain.SetParentComponent(wdsDashData);
    wdsDashDataRepMain.Name := 'wdsDashDataRepMain';
    wdsDashDataRepMain.FieldName := 'RepMain';
    wdsDashDataCostDescription.SetParentComponent(wdsDashData);
    wdsDashDataCostDescription.Name := 'wdsDashDataCostDescription';
    wdsDashDataCostDescription.FieldName := 'CostDescription';
    wdsDashDataTRegNo.SetParentComponent(wdsDashData);
    wdsDashDataTRegNo.Name := 'wdsDashDataTRegNo';
    wdsDashDataTRegNo.FieldName := 'TRegNo';
    wdsDashDataTFleetNo.SetParentComponent(wdsDashData);
    wdsDashDataTFleetNo.Name := 'wdsDashDataTFleetNo';
    wdsDashDataTFleetNo.FieldName := 'TFleetNo';
    wdsDashDataOrderNo.SetParentComponent(wdsDashData);
    wdsDashDataOrderNo.Name := 'wdsDashDataOrderNo';
    wdsDashDataOrderNo.FieldName := 'OrderNo';
    wdsDashDataJobDate.SetParentComponent(wdsDashData);
    wdsDashDataJobDate.Name := 'wdsDashDataJobDate';
    wdsDashDataJobDate.FieldName := 'JobDate';
    wdsDashDataReferenceNo.SetParentComponent(wdsDashData);
    wdsDashDataReferenceNo.Name := 'wdsDashDataReferenceNo';
    wdsDashDataReferenceNo.FieldName := 'ReferenceNo';
    wdsDashDataVehType.SetParentComponent(wdsDashData);
    wdsDashDataVehType.Name := 'wdsDashDataVehType';
    wdsDashDataVehType.FieldName := 'Vehtype';
    wdsDashDataJobType.SetParentComponent(wdsDashData);
    wdsDashDataJobType.Name := 'wdsDashDataJobType';
    wdsDashDataJobType.FieldName := 'JobType';
    wdsDashDataSupplier.SetParentComponent(wdsDashData);
    wdsDashDataSupplier.Name := 'wdsDashDataSupplier';
    wdsDashDataSupplier.FieldName := 'Supplier';
    wcDashboardSums.SetParentComponent(Self);
    wcDashboardSums.Name := 'wcDashboardSums';
    wcDashboardSums.Connection := dmData.dbConnect;
    wcDashboardSums.Left := 792;
    wcDashboardSums.Top := 249;
    dsDashBoardSums.SetParentComponent(Self);
    dsDashBoardSums.Name := 'dsDashBoardSums';
    dsDashBoardSums.DataSet := wdsDashboardSums;
    dsDashBoardSums.Left := 1080;
    dsDashBoardSums.Top := 241;
    wcDashData.SetParentComponent(Self);
    wcDashData.Name := 'wcDashData';
    wcDashData.Connection := dmData.dbConnect;
    wcDashData.Left := 280;
    wcDashData.Top := 344;
    dsDashData.SetParentComponent(Self);
    dsDashData.Name := 'dsDashData';
    dsDashData.DataSet := wdsDashData;
    dsDashData.Left := 184;
    dsDashData.Top := 400;
    wdsSuppliers.SetParentComponent(Self);
    wdsSuppliers.Name := 'wdsSuppliers';
    wdsSuppliers.AfterPost := wdsSuppliersAfterPost;
    wdsSuppliers.Connection := dmData.dbConnect;
    wdsSuppliers.Left := 1092;
    wdsSuppliers.Top := 80;
    wdsSuppliersCrName.SetParentComponent(wdsSuppliers);
    wdsSuppliersCrName.Name := 'wdsSuppliersCrName';
    wdsSuppliersCrName.FieldName := 'CrName';
    wdsSuppliersCrNumber.SetParentComponent(wdsSuppliers);
    wdsSuppliersCrNumber.Name := 'wdsSuppliersCrNumber';
    wdsSuppliersCrNumber.FieldName := 'CrNumber';
    wdsSuppliersSelected.SetParentComponent(wdsSuppliers);
    wdsSuppliersSelected.Name := 'wdsSuppliersSelected';
    wdsSuppliersSelected.FieldName := 'Selected';
    wcSuppliers.SetParentComponent(Self);
    wcSuppliers.Name := 'wcSuppliers';
    wcSuppliers.Connection := dmData.dbConnect;
    wcSuppliers.Left := 1068;
    wcSuppliers.Top := 160;
    dsSuppliers.SetParentComponent(Self);
    dsSuppliers.Name := 'dsSuppliers';
    dsSuppliers.DataSet := wdsSuppliers;
    dsSuppliers.Left := 1172;
    dsSuppliers.Top := 168;
    wdsVehGroups.SetParentComponent(Self);
    wdsVehGroups.Name := 'wdsVehGroups';
    wdsVehGroups.Connection := dmData.dbConnect;
    wdsVehGroups.Left := 1276;
    wdsVehGroups.Top := 80;
    wdsVehGroupsSysType.SetParentComponent(wdsVehGroups);
    wdsVehGroupsSysType.Name := 'wdsVehGroupsSysType';
    wdsVehGroupsSysType.FieldName := 'SysType';
    wdsVehGroupsDescription.SetParentComponent(wdsVehGroups);
    wdsVehGroupsDescription.Name := 'wdsVehGroupsDescription';
    wdsVehGroupsDescription.FieldName := 'Description';
    wdsVehGroupsSelected.SetParentComponent(wdsVehGroups);
    wdsVehGroupsSelected.Name := 'wdsVehGroupsSelected';
    wdsVehGroupsSelected.FieldName := 'Selected';
    wcVehGroups.SetParentComponent(Self);
    wcVehGroups.Name := 'wcVehGroups';
    wcVehGroups.Connection := dmData.dbConnect;
    wcVehGroups.Left := 1476;
    wcVehGroups.Top := 136;
    dsVehGroups.SetParentComponent(Self);
    dsVehGroups.Name := 'dsVehGroups';
    dsVehGroups.DataSet := wdsVehGroups;
    dsVehGroups.Left := 1324;
    dsVehGroups.Top := 152;
  finally
    pTop.AfterLoadDFMValues;
    pBottom.AfterLoadDFMValues;
    pMain.AfterLoadDFMValues;
    pMainTop.AfterLoadDFMValues;
    pMainMonths.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    btnMonthsClear.AfterLoadDFMValues;
    dgMonths.AfterLoadDFMValues;
    dgdaMonths.AfterLoadDFMValues;
    pMainYears.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    btnYearsClear.AfterLoadDFMValues;
    dgYears.AfterLoadDFMValues;
    dgdaYears.AfterLoadDFMValues;
    pRegNo.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    btnRegClear.AfterLoadDFMValues;
    dgReg.AfterLoadDFMValues;
    dgdaReg.AfterLoadDFMValues;
    pMaintTypes.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    dgSysTypes.AfterLoadDFMValues;
    dgdaSysTypes.AfterLoadDFMValues;
    pCostGroups.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    dgCostGroups.AfterLoadDFMValues;
    dgdaCostGroups.AfterLoadDFMValues;
    wpSuppliers.AfterLoadDFMValues;
    WebLabel18.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    dgSuppliers.AfterLoadDFMValues;
    dgdaSuppliers.AfterLoadDFMValues;
    wpVehGroups.AfterLoadDFMValues;
    WebLabel20.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    dgVehGroup.AfterLoadDFMValues;
    dgdaVehGroups.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    wpDashSums.AfterLoadDFMValues;
    wpTotalCost.AfterLoadDFMValues;
    WebDBLabel1.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebDBLabel10.AfterLoadDFMValues;
    wpMaintenance.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebDBLabel2.AfterLoadDFMValues;
    WebDBLabel11.AfterLoadDFMValues;
    wpTyres.AfterLoadDFMValues;
    WebDBLabel5.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebDBLabel12.AfterLoadDFMValues;
    wpCost.AfterLoadDFMValues;
    WebDBLabel3.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebDBLabel9.AfterLoadDFMValues;
    wpInsurance.AfterLoadDFMValues;
    WebDBLabel4.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebDBLabel13.AfterLoadDFMValues;
    wpOperational.AfterLoadDFMValues;
    WebDBLabel6.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebDBLabel14.AfterLoadDFMValues;
    wbSearch.AfterLoadDFMValues;
    wpCapex.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebDBLabel7.AfterLoadDFMValues;
    WebDBLabel15.AfterLoadDFMValues;
    wpUnAll.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebDBLabel8.AfterLoadDFMValues;
    WebDBLabel16.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    wbExcel.AfterLoadDFMValues;
    wpNoLink.AfterLoadDFMValues;
    WebLabel17.AfterLoadDFMValues;
    WebDBLabel17.AfterLoadDFMValues;
    WebDBLabel18.AfterLoadDFMValues;
    pDashData.AfterLoadDFMValues;
    dgDashData.AfterLoadDFMValues;
    dgdaDashData.AfterLoadDFMValues;
    WebWaitMessage1.AfterLoadDFMValues;
    BitmapContainer1.AfterLoadDFMValues;
    wcYears.AfterLoadDFMValues;
    wdsYears.AfterLoadDFMValues;
    wdsYearsSelected.AfterLoadDFMValues;
    wdsYearsYear.AfterLoadDFMValues;
    dsYears.AfterLoadDFMValues;
    wcMonths.AfterLoadDFMValues;
    wdsMonths.AfterLoadDFMValues;
    wdsMonthsMonth.AfterLoadDFMValues;
    wdsMonthsMonthName.AfterLoadDFMValues;
    wdsMonthsSelected.AfterLoadDFMValues;
    dsMonths.AfterLoadDFMValues;
    wcReg.AfterLoadDFMValues;
    wdsReg.AfterLoadDFMValues;
    wdsRegReg.AfterLoadDFMValues;
    wdsRegFleetNo.AfterLoadDFMValues;
    wdsRegFleetType.AfterLoadDFMValues;
    wdsRegSelected.AfterLoadDFMValues;
    wdsRegPriKey.AfterLoadDFMValues;
    dsReg.AfterLoadDFMValues;
    WebTimer1.AfterLoadDFMValues;
    wdsTempReg.AfterLoadDFMValues;
    StringField1.AfterLoadDFMValues;
    StringField2.AfterLoadDFMValues;
    StringField3.AfterLoadDFMValues;
    BooleanField1.AfterLoadDFMValues;
    IntegerField1.AfterLoadDFMValues;
    dsSysTypes.AfterLoadDFMValues;
    wcSysTypes.AfterLoadDFMValues;
    wdsSysTypes.AfterLoadDFMValues;
    wdsSysTypesSelected.AfterLoadDFMValues;
    wdsSysTypesSysType.AfterLoadDFMValues;
    wdsSysTypesDescription.AfterLoadDFMValues;
    wdsCostGroups.AfterLoadDFMValues;
    wdsCostGroupsselected.AfterLoadDFMValues;
    wdsCostGroupsCost.AfterLoadDFMValues;
    wdsCostGroupsDescription.AfterLoadDFMValues;
    dsCostGroups.AfterLoadDFMValues;
    wcCostGroups.AfterLoadDFMValues;
    wdsDashboardSums.AfterLoadDFMValues;
    wdsDashboardSumsMaintenanceCost.AfterLoadDFMValues;
    wdsDashboardSumsTyreCost.AfterLoadDFMValues;
    wdsDashboardSumsWashCost.AfterLoadDFMValues;
    wdsDashboardSumsInsuranceCost.AfterLoadDFMValues;
    wdsDashboardSumsOtherCost.AfterLoadDFMValues;
    wdsDashboardSumsTotalCost.AfterLoadDFMValues;
    wdsDashboardSumsCapexCost.AfterLoadDFMValues;
    wdsDashboardSumsUnallCost.AfterLoadDFMValues;
    wdsDashboardSumsTotalCPK.AfterLoadDFMValues;
    wdsDashboardSumsMaintenanceCPK.AfterLoadDFMValues;
    wdsDashboardSumsTyreCPK.AfterLoadDFMValues;
    wdsDashboardSumsWashCPK.AfterLoadDFMValues;
    wdsDashboardSumsInsuranceCPK.AfterLoadDFMValues;
    wdsDashboardSumsOtherCPK.AfterLoadDFMValues;
    wdsDashboardSumsCapexCPK.AfterLoadDFMValues;
    wdsDashboardSumsUnallCPK.AfterLoadDFMValues;
    wdsDashboardSumsNotLinkedCost.AfterLoadDFMValues;
    wdsDashboardSumsNotLinkedCPK.AfterLoadDFMValues;
    wdsDashData.AfterLoadDFMValues;
    wdsDashDataJobcardNo.AfterLoadDFMValues;
    wdsDashDataStockDescription.AfterLoadDFMValues;
    wdsDashDataTotalExcl.AfterLoadDFMValues;
    wdsDashDataGlCode.AfterLoadDFMValues;
    wdsDashDataReason.AfterLoadDFMValues;
    wdsDashDataCategory.AfterLoadDFMValues;
    wdsDashDataRepMain.AfterLoadDFMValues;
    wdsDashDataCostDescription.AfterLoadDFMValues;
    wdsDashDataTRegNo.AfterLoadDFMValues;
    wdsDashDataTFleetNo.AfterLoadDFMValues;
    wdsDashDataOrderNo.AfterLoadDFMValues;
    wdsDashDataJobDate.AfterLoadDFMValues;
    wdsDashDataReferenceNo.AfterLoadDFMValues;
    wdsDashDataVehType.AfterLoadDFMValues;
    wdsDashDataJobType.AfterLoadDFMValues;
    wdsDashDataSupplier.AfterLoadDFMValues;
    wcDashboardSums.AfterLoadDFMValues;
    dsDashBoardSums.AfterLoadDFMValues;
    wcDashData.AfterLoadDFMValues;
    dsDashData.AfterLoadDFMValues;
    wdsSuppliers.AfterLoadDFMValues;
    wdsSuppliersCrName.AfterLoadDFMValues;
    wdsSuppliersCrNumber.AfterLoadDFMValues;
    wdsSuppliersSelected.AfterLoadDFMValues;
    wcSuppliers.AfterLoadDFMValues;
    dsSuppliers.AfterLoadDFMValues;
    wdsVehGroups.AfterLoadDFMValues;
    wdsVehGroupsSysType.AfterLoadDFMValues;
    wdsVehGroupsDescription.AfterLoadDFMValues;
    wdsVehGroupsSelected.AfterLoadDFMValues;
    wcVehGroups.AfterLoadDFMValues;
    dsVehGroups.AfterLoadDFMValues;
  end;
end;

end.
